webpackJsonp([6],{

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(831),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20ab93f1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ls = __webpack_require__(27);
var configurations = __webpack_require__(33);
var cloudinarySettings = configurations.cloudinary_settings;
var cloud_name = configurations.cloudinary_cloudName;
var upload_preset = configurations.cloudinary_preset;

/* harmony default export */ __webpack_exports__["a"] = ({
  //
  data: function data() {
    return {
      uploadedImgUrl: ''
    };
  },

  //
  created: function created() {
    // two set interval cz -> a page can have 2 search.
    // 1
    setInterval(function () {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast != window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage && window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast = window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage;

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags_uploadImage
        });

        console.log("[CALLING SEARCH.........]");
      } else {}
    }, 500);
    //
    // 2
    setInterval(function () {
      if (window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 != window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage && window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag.length != 0) {

        window.thisOfVueComp.$store.state.uploadImage_2.qStr_thisTagWasSearchedLast2 = window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage;

        window.thisOfVueComp.$store.commit('getTags_setDropdownOptions_uploadImage', {
          qTag: window.thisOfVueComp.$store.state.uploadImage_2.qStr_searchThisTag,
          qStr: window.thisOfVueComp.$store.state.uploadImage_2.qStr_tags2_uploadImage
        });

        console.log("[CALLING SEARCH.........]");
      } else {}
    }, 500);
    //
    var str = ls.get('thumbnailImgUrl');
    var id = str.split('/')[str.split('/').length - 1];
    this.uploadedImgUrl = 'https://res.cloudinary.com/' + cloud_name + '/image/upload/w_600,h_400,c_fill,' + cloudinarySettings + '/' + upload_preset + '/' + id;
    console.log("[uploadedImgUrl] => ", this.uploadedImgUrl);
    //
  }
});

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(576), __esModule: true };

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(574);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(577);
var $Object = __webpack_require__(12).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(28);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(42), 'Object', { defineProperty: __webpack_require__(54).f });


/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var vm = void 0;
/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    emitArrayAsTextObjArr: function emitArrayAsTextObjArr() {
      // console.log("Modal Will be closing now!!! :O");
      var arr = [];
      for (var i in this.selectedSuggestions) {
        arr.push(this.selectedSuggestions[i]);
      }
      var payload = {
        arr: arr,
        tagCatType: vm.suggestionTag
      };
      this.$emit("arrayval", payload);
      this.$modal.hide("suggestions");
    },

    //
    addOrRemove: function addOrRemove(suggestion) {
      if (this.selectedSuggestions.includes(suggestion)) {
        var ind = this.selectedSuggestions.indexOf(suggestion);
        this.selectedSuggestions.splice(ind, 1);
      } else {
        this.selectedSuggestions.push(suggestion);
      }
    },

    //
    addTagToSelected: function addTagToSelected() {
      var re = /^$/;
      console.log({ RE_TEST_VAL: re.test(this.addTagModal) });
      if (!re.test(this.addTagModal)) {
        this.selectedSuggestions.push(this.addTagModal);
        this.addTagModal = "";
        this.$modal.hide("add-new-suggestion");
      } else {
        this.$store.commit("snackbar_alert", { msg: "Tag cannot be empty!" });
      }
    }
  },
  //
  data: function data() {
    return {
      addTagModal: "",
      selectedSuggestions: [],
      suggestions: []
    };
  },

  //
  props: ["arr", "suggestionTag", "headTag", "subheadTag"],
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _res, i, _i, res, _i2;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              vm = _this;

              if (!(vm.suggestionTag === "keywords")) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return _this.$store.dispatch("getImaggaSuggestions", {
                publicId: _this.$route.query.publicId
              });

            case 4:
              _res = _context.sent;

              // console.log({ RES: res });
              for (i in _res.tags) {
                _this.suggestions.push(_res.tags[i].tag);
              }

            case 6:

              for (_i in _this.arr) {
                _this.selectedSuggestions.push(_this.arr[_i]);
              }
              // console.log({ suggestionTag: vm.suggestionTag });
              _context.next = 9;
              return _this.$store.dispatch("GET_SUGGESTIONS", {
                tagCatType: vm.suggestionTag
              });

            case 9:
              res = _context.sent;

              // console.log({ res });

              //
              for (_i2 in res.tags) {
                if (res.tags[_i2].tag !== "all") {
                  _this.suggestions.push(res.tags[_i2].tag);
                }
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var vm = void 0;
/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    fillTravelInfo: function fillTravelInfo() {
      this.$store.state.uploadImage_3.travelInfo = this.travel;
      this.travel = '';
      this.$modal.hide('suggestions');
    }
  },
  //
  data: function data() {
    return {
      travel: ''
    };
  },

  //
  props: ['suggestionTag', 'headTag', 'subheadTag', 'textVal'],
  mounted: function mounted() {
    setTimeout(function () {
      var ele = document.getElementsByTagName('textarea')[0];
      ele.focus();
    }, 20);
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              vm = _this;
              _this.travel = _this.textVal;

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geo_hash__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geo_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_geo_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_js_toggle_button__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__travel_info__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__travel_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__travel_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__suggestion_model__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__suggestion_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__suggestion_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixin_uploadImage__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_dateTimeOrgIndex__ = __webpack_require__(215);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//

//



//
/* harmony default export */ __webpack_exports__["default"] = ({
  // compbox data
  metaInfo: function metaInfo() {
    return {
      title: "with a view"
    };
  },

  data: function data() {
    var _ref;

    return _ref = {
      selectedSuggestionModel: "",
      dummyArr: [],
      mapTooltip: false,
      items: [],
      model: [],
      imageLocation: "",
      selectedVibeSuggestions: [],
      selectedSpotType: [],
      activator: null,
      attach: null,
      addTagModal: "",
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      index: -1,
      currentDate: "",
      vibeSuggestions: ["romantic", "chill", "relax", "stunning", "spiritual", "energetic", "breathtaking", "party"],
      spotSuggestions: ["airbnb", "bar", "hotel room", "private window", "restaurant", "balcony", "office", "pool", "penthouse", "rooftop bar", "terrace"],
      nonce: 1,
      menu: false,
      x: 0,
      search: null,
      search2: null,
      y: 0,
      time: "",
      date: ""
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "menu", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "modal", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "menu2", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "modal2", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "_mon2", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "_dur2", ""), _ref;
  },
  // compbox watch
  watch: {
    "$store.state.uploadImage_2.openMapDialog": {
      handler: function handler() {
        var _this = this;

        if (this.$store.state.uploadImage_2.openMapDialog) {
          setTimeout(function () {
            _this.$store.commit("getMarkerOnCurrentLoc", {
              isLocAvailable: _this.$route.query.geoLocIsAvailable,
              geohash: _this.$route.query.geohash
            });
          }, 200);
        }
      }
    }
  },

  //
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixin_uploadImage__["a" /* default */]],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapMutations */])(["goTo_uploadImage_3", "getMarkerPosition", "getCurrentGeoLocation", "selectMarkerLocation"]), {
    showMapTooltip: function showMapTooltip() {
      console.log("showMapTooltip");
      this.mapTooltip = true;
    },
    hideMapTooltip: function hideMapTooltip() {
      console.log("hideMapTooltip");
      this.mapTooltip = false;
    },
    addTagToSelected: function addTagToSelected(type) {
      if (type == "EA") {
        if (this.vibeSuggestions.includes(this.addTagModal)) {
          this.addTagModal = "";
        } else {
          this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.push(this.addTagModal);
          this.vibeSuggestions.push(this.addTagModal);
          this.addTagModal = "";
          setTimeout(function (scope) {
            var element = document.getElementById("ea" + (scope.vibeSuggestions.length - 1));
            element.classList.remove("unselected-suggestion-pills");
            var name = "selected-suggestion-pills";
            var arr = element.className.split(" ");
            if (arr.indexOf(name) == -1) {
              element.className += " " + name;
            }
          }, 10, this);
        }
        this.$modal.hide("add-new-ea-suggestion");
      } else {
        if (this.spotSuggestions.includes(this.addTagModal)) {
          this.addTagModal = "";
        } else {
          this.$store.state.uploadImage_4.selectedSpotType_uploadImage.push(this.addTagModal);

          this.spotSuggestions.push(this.addTagModal);
          setTimeout(function (scope) {
            var element = document.getElementById("s" + (scope.spotSuggestions.length - 1));
            element.classList.remove("unselected-suggestion-pills");
            var name = "selected-suggestion-pills";
            var arr = element.className.split(" ");
            if (arr.indexOf(name) == -1) {
              element.className += " " + name;
            }
          }, 10, this);
          this.addTagModal = "";
        }
        this.$modal.hide("add-new-spot-suggestion");
      }
    },
    getVideoLink: function getVideoLink(link) {
      var words = link.split("/");
      var id = words[3];
      return "https://player.vimeo.com/video/" + id + "?title=0&byline=0&portrait=0";
    },
    getVideoId: function getVideoId(link) {
      var videoId = "";
      if (link.includes("youtu.be")) {
        videoId = link.split("/")[3];
        if (videoId.search("#") !== -1) {
          videoId = videoId.split("#")[0];
        }
        if (videoId.search("/?") !== -1) {
          videoId = videoId.split("?")[0];
        }
      } else {
        var url = new URL(link);
        videoId = url.searchParams.get("v");
      }
      return videoId;
    },
    shareUploadedImage: function shareUploadedImage(payload) {
      console.log("**********************", {
        shareUploadedImagePayload: payload
      });
      this.$store.dispatch("SHARE_UPLOAD_IMAGE", payload);
    },

    //
    addOrRemove: function addOrRemove(suggestion, type, id) {
      if (type == "EA") {
        if (this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.includes(suggestion)) {
          var ind = this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.indexOf(suggestion);
          this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.splice(ind, 1);
          var element = document.getElementById(id);
          element.classList.remove("selected-suggestion-pills");
          var element, _name, _arr;
          var _name = "unselected-suggestion-pills";
          var _arr = element.className.split(" ");
          if (_arr.indexOf(_name) == -1) {
            element.className += " " + _name;
          }
        } else {
          this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.push(suggestion);
          var element = document.getElementById(id);
          element.classList.remove("unselected-suggestion-pills");
          var element, _name2, _arr2;
          var _name2 = "selected-suggestion-pills";
          var _arr2 = element.className.split(" ");
          if (_arr2.indexOf(_name2) == -1) {
            element.className += " " + _name2;
          }
        }
      } else if (type == "spot") {
        if (this.$store.state.uploadImage_4.selectedSpotType_uploadImage.includes(suggestion)) {
          var _ind = this.$store.state.uploadImage_4.selectedSpotType_uploadImage.indexOf(suggestion);
          this.$store.state.uploadImage_4.selectedSpotType_uploadImage.splice(_ind, 1);
          var element = document.getElementById(id);
          element.classList.remove("selected-suggestion-pills");
          var element, _name3, _arr3;
          var _name3 = "unselected-suggestion-pills";
          var _arr3 = element.className.split(" ");
          if (_arr3.indexOf(_name3) == -1) {
            element.className += " " + _name3;
          }
        } else {
          this.$store.state.uploadImage_4.selectedSpotType_uploadImage.push(suggestion);
          var element = document.getElementById(id);
          element.classList.remove("unselected-suggestion-pills");
          var element, _name4, _arr4;
          var _name4 = "selected-suggestion-pills";
          var _arr4 = element.className.split(" ");
          if (_arr4.indexOf(_name4) == -1) {
            element.className += " " + _name4;
          }
        }
      }
    },

    //
    FillSelectedArrayValue: function FillSelectedArrayValue(val) {
      // console.log({ FillSelectedArrayValue: val });
      var type = val.tagCatType;
      var arr = val.arr;
      switch (type) {
        case "emotionalAppeal":
          {
            this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage = arr;
            // console.log({
            //   EMOTIONAL_NOW: this.$store.state.uploadImage_2
            //     .selectedemotionalAppeal_uploadImage
            // });
            this.$forceUpdate();
            break;
          }
        case "spotType":
          {
            this.$store.state.uploadImage_4.selectedSpotType_uploadImage = arr;
            this.$forceUpdate();
            break;
          }
        case "keywords":
          {
            this.$store.state.uploadImage_5.selectedKeywords_uploadImage = arr;
            this.$forceUpdate();
            break;
          }
      }
    },

    // compbox methods
    edit: function edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.index = index;
      } else {
        this.editing = null;
        this.index = -1;
      }
    },
    filter: function filter(item, queryText, itemText) {
      if (item.header) return false;

      var hasValue = function hasValue(val) {
        return val != null ? val : "";
      };

      var text = hasValue(itemText);
      var query = hasValue(queryText);

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1;
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(["showHideMapInput", "showMap", "addressDetails", "locationAddress"]), {
    submittableDateTime: function submittableDateTime() {
      if (this.date != "") {
        var date = new Date(this.date);
        if (this.time != "") {
          var hours = this.time.match(/^(\d+)/)[1];
          var minutes = this.time.match(/:(\d+)/)[1];
          date.setHours(hours);
          date.setMinutes(minutes);
          var createdAt_date = this.date;
          var createdAt_time = this.time;
          this.$store.state.uploadImage_2.createdAt = createdAt_date + "T" + createdAt_time + "Z"; //2017-12-21T18:14:58Z //format
          var _mon = this.$store.state.uploadImage_2.createdAt[5] + this.$store.state.uploadImage_2.createdAt[6];
          this._mon2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helper_dateTimeOrgIndex__["a" /* _index_mon */])(_mon);
          // console.log(this._mon2);
          var _dur = parseInt(this.$store.state.uploadImage_2.createdAt[11] + this.$store.state.uploadImage_2.createdAt[12]);
          this._dur2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helper_dateTimeOrgIndex__["b" /* _index_dur */])(_dur);
          // console.log(this._dur2);
        }
      }
    },
    parsedEmotionalType: function parsedEmotionalType() {
      var a = [];
      for (var i in this.$store.state.uploadImage_2.emotionalAppeal_uploadImage) {
        console.log("1 ", this.$store.state.uploadImage_2.emotionalAppeal_uploadImage[i]);
        var tmp = {
          text: this.$store.state.uploadImage_2.emotionalAppeal_uploadImage[i]
        };
        a.push(tmp);
      }
      return a;
    },
    parsedSpotType: function parsedSpotType() {
      var a = [];
      for (var i in this.$store.state.uploadImage_4.spotType_uploadImage) {
        // console.log(
        //   `1 `,
        //   this.$store.state.uploadImage_4.spotType_uploadImage[i]
        // );
        var tmp = {
          text: this.$store.state.uploadImage_4.spotType_uploadImage[i]
        };
        a.push(tmp);
      }
      return a;
    }
  }),
  created: function created() {
    var vm = this;
    this.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage = true;
    this.$store.state.uploadImage_3.locationAddress = "";
    this.$store.state.uploadImage_3.geohashVal = this.$route.query.geohash;
    this.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3 = JSON.parse(this.$route.query.geoLocIsAvailable);
    if (JSON.parse(this.$route.query.geoLocIsAvailable)) {
      //console.log('1', geo.decode(payload.geohash))
      var lat = __WEBPACK_IMPORTED_MODULE_2_geo_hash___default.a.decode(this.$route.query.geohash).lat;
      var lng = __WEBPACK_IMPORTED_MODULE_2_geo_hash___default.a.decode(this.$route.query.geohash).lon;

      this.$store.commit("getInitAddress", {
        lat: lat,
        lng: lng
      });
    }
    this.$store.state.uploadImage_2.qStr_searchThisTag = "";
    this.$store.state.uploadImage_2.caption_uploadImage = "";
    this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage = [];
    this.$store.state.uploadImage_2.qStr_tags2_uploadImage = [];
    this.$store.state.uploadImage_4.selectedSpotType_uploadImage = [];
    this.$store.state.uploadImage_2.qStr_tags2_uploadImage = [];
    window.thisOfVueComp = this;

    setTimeout(function () {
      /*this.$store.commit('getMarkerOnCurrentLoc', {
          isLocAvailable:vm.$route.query.geoLocIsAvailable,
          geohash: vm.$route.query.geohash
        }) */
    }, 1000);
    //
    this.$store.commit("setEmptyVar_ls"); //set local storgae to empty array.
    //
    this.$store.state.uploadImage_2.createdAt = this.$route.query.createdAt;
    this._mon2 = this.$route.query._mon2;
    this._dur2 = this.$route.query._dur2;
    var curDate = new Date();
    var curFullYear = curDate.getFullYear();
    var curMonth = curDate.getMonth() + 1;
    var curDay = curDate.getDate();
    if (curDay < 10) {
      curDay = "0" + curDay;
    }
    this.currentDate = curFullYear + "-" + curMonth + "-" + curDay;
  },

  components: {
    suggestionModal: __WEBPACK_IMPORTED_MODULE_6__suggestion_model___default.a,
    travelModal: __WEBPACK_IMPORTED_MODULE_5__travel_info___default.a,
    ToggleButton: __WEBPACK_IMPORTED_MODULE_3_vue_js_toggle_button__["ToggleButton"]
  },
  mounted: function mounted() {
    this.$store.commit("getSpotTypeSuggestions_fromLocalStorage");
  }
  //

});

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".upload-screen-1-container[data-v-20ab93f1]{background-color:#000;overflow-y:scroll;height:100vh;width:100%;padding:25px}.upload-screen-1-container .add-new-btn-suggestion[data-v-20ab93f1]{width:90px;color:#000;font-size:12px;padding:5px;border-radius:8px;background-color:#fff;margin-left:50px}.upload-screen-1-container .actions[data-v-20ab93f1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.upload-screen-1-container .actions .upload-title[data-v-20ab93f1]{font-family:Montserrat;font-size:21px;font-weight:800;color:#fff;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:left;margin-left:10px}.upload-screen-1-container .actions i[data-v-20ab93f1]{font-size:1em}.upload-screen-1-container .actions .done[data-v-20ab93f1]{color:#fff;font-size:1.1em;border-radius:6px;padding:15px 33px;font-family:Montserrat;font-size:14px;font-weight:700}.upload-screen-1-container .hr-text[data-v-20ab93f1]{line-height:1em;position:relative;outline:0;border:0;color:#000;text-align:center;height:1.5em;opacity:.5}.upload-screen-1-container .hr-text[data-v-20ab93f1]:before{content:\"\";background:#818078;position:absolute;left:0;top:50%;width:100%;height:1px}.upload-screen-1-container .hr-text[data-v-20ab93f1]:after{margin-top:-6px;font-size:24px;-webkit-font-feature-settings:\"liga\";position:relative;margin-left:-100%;display:inline-block;font-family:Material Icons;content:\"keyboard_backspace\";-webkit-font-feature-settings:\"liga\" 1;font-feature-settings:\"liga\" 1;padding:0 .5em;line-height:1.5em;color:#818078;background-color:#fcfcfa}.upload-screen-1-container .input-container[data-v-20ab93f1]{margin-bottom:15px;width:100%;position:relative}.upload-screen-1-container .input-container .input-arrow-icon[data-v-20ab93f1]{font-size:1.1em;position:absolute;right:0;top:1em;color:#9b9b9b}.upload-screen-1-container .input-container .public-access-toggle[data-v-20ab93f1]{top:0;right:0;position:absolute}.upload-screen-1-container .input-container .location-icon[data-v-20ab93f1]{top:20%;right:0;position:absolute}.upload-screen-1-container .input-container .input-label[data-v-20ab93f1]{margin-top:1em;color:#fff;text-align:left;font-family:Montserrat;font-size:12px;font-weight:800}@media (max-width:330px){.upload-screen-1-container .input-container .input-label[data-v-20ab93f1]{font-size:1em}}.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1]{width:100%;height:100%;outline:none}.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1] ::-webkit-input-placeholder{font-size:1em}.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1] :-ms-input-placeholder,.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1] ::-ms-input-placeholder{font-size:1em}.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1] ::placeholder{font-size:1em}.upload-screen-1-container .input-container .input-container-text[data-v-20ab93f1]{font-size:.857em;text-align:left}.upload-screen-1-container .important-details-container[data-v-20ab93f1]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;position:relative}.upload-screen-1-container .important-details-container .back-icon[data-v-20ab93f1]{position:absolute;left:0;top:58%}.upload-screen-1-container .important-details-container .important-details[data-v-20ab93f1]{width:98%;text-align:right;font-size:1.286em;font-weight:700}.upload-screen-1-container .important-details-container .hr-div[data-v-20ab93f1]{margin-left:20px;position:absolute;width:90%;top:58%;left:20px;background:#d3d3d3;height:1px}.upload-screen-1-container .img-and-caption-container[data-v-20ab93f1]{margin:5px 0 0}.upload-screen-1-container .img-and-caption-container .img-container img[data-v-20ab93f1]{width:100%;max-width:600px;height:400px;-o-object-fit:contain;object-fit:contain}.upload-screen-1-container .img-and-caption-container .img-container .video-container[data-v-20ab93f1]{width:100%;height:100%}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access[data-v-20ab93f1],.upload-screen-1-container .img-and-caption-container .img-container .video-container[data-v-20ab93f1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .inner-container[data-v-20ab93f1]{display:-webkit-box;display:-ms-flexbox;display:flex;min-width:600px}@media only screen and (max-width:1280px){.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .inner-container[data-v-20ab93f1]{min-width:100%}}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .sub-text[data-v-20ab93f1]{text-align:right;font-family:Montserrat;font-size:10px;color:#b9b9b9!important}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .heading-text[data-v-20ab93f1]{margin-right:25px;text-align:right}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container[data-v-20ab93f1]{display:block;position:relative;padding-left:35px;margin-bottom:12px;cursor:pointer;font-size:22px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container input[data-v-20ab93f1]{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .checkmark[data-v-20ab93f1]{position:absolute;top:0;right:0;height:18px;width:18px;background-color:#eee;margin-top:8px}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container:hover input~.checkmark[data-v-20ab93f1]{background-color:#ccc}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container input:checked~.checkmark[data-v-20ab93f1]{background-color:#b9b9b9}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .checkmark[data-v-20ab93f1]:after{content:\"\";position:absolute;display:none}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container input:checked~.checkmark[data-v-20ab93f1]:after{display:block}.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container .checkmark[data-v-20ab93f1]:after{left:7px;top:1px;width:6px;height:12px;border:solid #000;border-width:0 3px 3px 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.upload-screen-1-container .img-and-caption-container .caption-container[data-v-20ab93f1]{padding-left:10px;text-align:left}.upload-screen-1-container .img-and-caption-container .caption-container .caption-title[data-v-20ab93f1]{font-family:Montserrat;font-size:21px;font-weight:500;color:#b9b9b9}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1]{width:100%;outline:none;resize:none;font-family:Montserrat;font-size:21px;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#f5a623;height:90px;padding:8px;border:.2px solid hsla(0,0%,73%,.5)}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1]::-webkit-input-placeholder{color:#5b5b5b}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1]:-ms-input-placeholder,.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1]::-ms-input-placeholder{color:#5b5b5b}.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1]::placeholder{color:#5b5b5b}.upload-screen-1-container .selected-tags-upload[data-v-20ab93f1]{font-size:.939em;font-weight:500;color:#fff}.upload-screen-1-container input[type=color][data-v-20ab93f1],.upload-screen-1-container input[type=date][data-v-20ab93f1],.upload-screen-1-container input[type=datetime-local][data-v-20ab93f1],.upload-screen-1-container input[type=datetime][data-v-20ab93f1],.upload-screen-1-container input[type=email][data-v-20ab93f1],.upload-screen-1-container input[type=month][data-v-20ab93f1],.upload-screen-1-container input[type=number][data-v-20ab93f1],.upload-screen-1-container input[type=password][data-v-20ab93f1],.upload-screen-1-container input[type=search][data-v-20ab93f1],.upload-screen-1-container input[type=tel][data-v-20ab93f1],.upload-screen-1-container input[type=text][data-v-20ab93f1],.upload-screen-1-container input[type=time][data-v-20ab93f1],.upload-screen-1-container input[type=url][data-v-20ab93f1],.upload-screen-1-container input[type=week][data-v-20ab93f1],.upload-screen-1-container select[data-v-20ab93f1]:focus,.upload-screen-1-container textarea[data-v-20ab93f1]{font-size:16px}.upload-screen-1-container .all-selected-suggestions[data-v-20ab93f1]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;font-family:Montserrat;font-size:12px}.upload-screen-1-container .all-selected-suggestions .tags[data-v-20ab93f1]{margin-right:.4em;margin-bottom:.4em}.upload-screen-1-container .selected-suggestions[data-v-20ab93f1]{border:.2px solid hsla(0,0%,73%,.5);font-family:Montserrat;font-size:12px!important;color:#f5a623;padding:8px;margin-bottom:5px;width:100%}.upload-screen-1-container .selected-suggestions .selected-tags-placeholder[data-v-20ab93f1]{color:#b9b9b9}.upload-screen-1-container .location-container[data-v-20ab93f1]{display:-webkit-box;display:-ms-flexbox;display:flex}.upload-screen-1-container .location-container .add-location[data-v-20ab93f1]{outline:none;background-color:#b9b9b9;color:#000;padding:5px 17px;border-radius:6px;position:relative;font-family:Montserrat;font-size:12px;font-weight:700}.upload-screen-1-container .location-container .add-location .location-button[data-v-20ab93f1]{display:-webkit-box;display:-ms-flexbox;display:flex}.upload-screen-1-container .location-container .add-location .address[data-v-20ab93f1]{margin-top:5px;font-family:Montserrat;font-size:12px!important}.upload-screen-1-container .location-container .add-location-new[data-v-20ab93f1]{background-color:#f5a623;color:#000;padding:5px 17px;border-radius:6px;position:relative;font-family:Montserrat;font-size:12px;font-weight:700}.upload-screen-1-container .location-container .add-location-new .location-button[data-v-20ab93f1]{display:-webkit-box;display:-ms-flexbox;display:flex}.upload-screen-1-container .image-datetime-upload-heading[data-v-20ab93f1]{font-family:Montserrat;font-size:12px;font-weight:500;margin-top:15px;color:#fff}.upload-screen-1-container .video-input-box[data-v-20ab93f1]{border:.2px solid #b9b9b9;font-family:Montserrat;font-size:12px;min-width:650px;padding:5px;color:#f5a623}.upload-screen-1-container .date-time-input-box[data-v-20ab93f1]{border:.2px solid #b9b9b9;font-family:Montserrat;font-size:12px;padding:5px;width:50%;color:#f5a623;margin-bottom:10px;margin-right:10px;cursor:pointer}.upload-screen-1-container .suggestions-container[data-v-20ab93f1]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.upload-screen-1-container .suggestions-container .unselected-suggestion-pills[data-v-20ab93f1]{font-family:Montserrat;font-size:12px;color:#b9b9b9;padding:5px;border-radius:8px;margin-right:10px;margin-bottom:5px;border:.2px solid hsla(0,0%,73%,.5)}.upload-screen-1-container .suggestions-container .unselected-suggestion-pills button[data-v-20ab93f1]{outline:none!important}.upload-screen-1-container .suggestions-container .selected-suggestion-pills[data-v-20ab93f1]{font-family:Montserrat;font-size:12px;color:#000;background-color:#fff;padding:5px;border-radius:8px;margin-right:10px;margin-bottom:5px}.upload-screen-1-container .suggestions-container .selected-suggestion-pills button[data-v-20ab93f1]{outline:none!important}.main-container .add-tag-container[data-v-20ab93f1]{padding:2em}.main-container .add-tag-container .tag-add-button[data-v-20ab93f1]{border-radius:.5em;padding:.3em;width:100%;margin-top:2em;outline:none;background-color:#000;color:#fff;border:1px solid #f5a623}.main-container .head-section[data-v-20ab93f1]{padding:0 1em;color:#fff}.main-container .head-section .actions[data-v-20ab93f1]{padding-top:1.629em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.main-container .head-section .actions i[data-v-20ab93f1]{font-size:1em}.main-container .head-section .actions .done[data-v-20ab93f1]{font-size:1.1em;font-weight:700;border-radius:.5em;padding:.3em;margin-top:2em;padding-left:1em;padding-right:1em;outline:none;background-color:#bd10e0;color:#fff;border:1px solid #000}.main-container .head-section .head[data-v-20ab93f1]{padding-right:2em;font-size:1.1em}.main-container .input-section[data-v-20ab93f1]{min-height:5.643em;margin-top:1.857em;border-top:.5px solid #000;border-bottom:.5px solid #000;position:relative}.main-container .input-section .clickable-modal-bg[data-v-20ab93f1]{background:transparent;position:absolute;width:100%;height:100%;z-index:1}.main-container .input-section .input-header[data-v-20ab93f1]{left:1em;top:-1em;position:absolute;padding:.3em .5em;background-color:#4a4a4a;color:#9b9b9b}.main-container .input-section .add-new-btn-suggestion[data-v-20ab93f1]{cursor:pointer;top:-1em;position:absolute;padding:.3em 1.2em;right:1em;background-color:#000;color:#fff;outline:none;border-radius:.5em;border:1px solid #9b9b9b;font-size:.857em}.main-container .input-section .selected-suggestions[data-v-20ab93f1]{padding:1.5em 1em}.main-container .input-section .selected-suggestions .default-text[data-v-20ab93f1]{text-align:center;font-size:.9em;color:#f5a623}.main-container .input-section .selected-suggestions .default-text textarea[data-v-20ab93f1]{width:100%;font-size:16px;outline:none;resize:unset}.main-container .input-section .selected-suggestions[data-v-20ab93f1]::-webkit-input-placeholder{color:#b9b9b9;opacity:1}.main-container .input-section .selected-suggestions[data-v-20ab93f1]:-ms-input-placeholder,.main-container .input-section .selected-suggestions[data-v-20ab93f1]::-ms-input-placeholder{color:#b9b9b9;opacity:1}.main-container .input-section .selected-suggestions[data-v-20ab93f1]::placeholder{color:#b9b9b9;opacity:1}.main-container .input-section .suggestions-container .added-suggestions[data-v-20ab93f1]{z-index:4;margin-right:.8em;margin-bottom:.4em;padding:0 2.5em 0 1em;background-color:#000;color:#fff;border:1px solid #f5a623;position:relative;outline:none;text-transform:capitalize}.main-container .input-section .suggestions-container .added-suggestions i[data-v-20ab93f1]{position:absolute;right:.5em;font-size:1em;top:.2em}.main-container .suggestion-section[data-v-20ab93f1]{padding:1.5em .5em 0 1em}.main-container .suggestion-section .suggestion-head[data-v-20ab93f1]{font-size:1em;color:#9b9b9b}.main-container .suggestion-section .suggestions-container[data-v-20ab93f1]{margin-top:.5em;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.main-container .suggestion-section .selected-suggestion[data-v-20ab93f1]{z-index:4;margin-right:.8em;margin-bottom:.4em;padding:0 2.5em 0 1em;background-color:#9b9b9b;color:#4a4a4a;border:1px solid #9b9b9b;position:relative;outline:none;text-transform:capitalize}.main-container .suggestion-section .selected-suggestion i[data-v-20ab93f1]{position:absolute;right:.5em;font-size:1em;top:.2em}.main-container .suggestion-section .unselected-suggestion[data-v-20ab93f1]{z-index:4;margin-right:.8em;margin-bottom:.4em;padding:0 2.5em 0 1em;background-color:#4a4a4a;color:#fff;border:1px solid #9b9b9b;position:relative;outline:none;text-transform:capitalize}.main-container .suggestion-section .unselected-suggestion i[data-v-20ab93f1]{position:absolute;right:.5em;font-size:1em;top:.2em}.tooltip[data-v-20ab93f1]{position:relative;display:inline-block;border-bottom:1px dotted #000}.tooltip .tooltiptext[data-v-20ab93f1]{max-width:300px;background-color:#000;border:.2px solid #fff;border-radius:5px;color:#fff;text-align:center;border-radius:6px;padding:10px;position:absolute;z-index:1;top:110%;left:0;margin-left:-60px;opacity:0;-webkit-transition:opacity .3s;transition:opacity .3s}.tooltip .tooltiptext[data-v-20ab93f1]:before{content:\"\";position:absolute;top:-11px;left:50%;margin-right:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #fff}.tooltip:hover .tooltiptext[data-v-20ab93f1]{opacity:1}.border-bottom[data-v-20ab93f1]{border-bottom:.5px solid hsla(0,0%,61%,.5)}.padding-bottom[data-v-20ab93f1]{padding-bottom:1em}.padding-top[data-v-20ab93f1]{padding-top:1em}#myMap[data-v-20ab93f1]{height:60vh;width:100%;z-index:10!important}#pac-input[data-v-20ab93f1]{z-index:1000!important;position:relative;padding:10px 3.5em 10px 10px;outline:none;width:100%}#pac-input .pac-container[data-v-20ab93f1]{position:absolute!important;z-index:1000!important;top:0;-webkit-box-shadow:none;box-shadow:none;font-family:Lato,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}#pac-input .pac-item[data-v-20ab93f1]{background:transparent url(\"https://png.icons8.com/ios/22/000000/marker.png\") no-repeat 22px;position:relative;line-height:20px;padding:15px 25px 15px 65px}#pac-input .pac-item span[data-v-20ab93f1]:nth-child(3):before{content:\"\\A\";white-space:pre}#pac-input .pac-item[data-v-20ab93f1]:hover{background-color:#d3d3d3}#pac-input .pac-item-query[data-v-20ab93f1]{font-weight:700}#pac-input div.pac-container.pac-logo[data-v-20ab93f1]:after{display:none}.search-loc-loc-me[data-v-20ab93f1]{margin-top:5px}.true[data-v-20ab93f1]{visibility:visible}.false[data-v-20ab93f1]{visibility:hidden}.image-thumbnail[data-v-20ab93f1]{-o-object-fit:contain;object-fit:contain}.my-loc-btn[data-v-20ab93f1]{position:absolute;right:20px;top:10px}.select-loc-btn[data-v-20ab93f1]{width:100%;padding:10px 20px;text-align:center;background-color:#000;color:#fff;opacity:1;font-family:Montserrat}.select-loc-btn-disabled[data-v-20ab93f1]{width:100%;padding:10px 20px;text-align:center;opacity:.9;font-family:Montserrat;background-color:#5b5b5b;color:#9b9b9b}.travel-info[data-v-20ab93f1]{outline:none;border-bottom:1px solid #fff!important;width:100%}.video-player-youtube[data-v-20ab93f1]{position:relative;height:100%;width:100%}.share-btn-container[data-v-20ab93f1]{left:0;width:100%;position:absolute;bottom:1.5em}.share-img-btn[data-v-20ab93f1]{margin-top:2em;max-width:270px;width:100%;background-color:#000;color:#fff;font-size:.9em;line-height:2;border-radius:6px}.map-tooltiptext[data-v-20ab93f1]{position:absolute;z-index:10;top:-35px;left:0;background-color:#000;border:.2px solid #fff;border-radius:5px;color:#fff;padding:5px;text-align:center}.map-tooltiptext[data-v-20ab93f1]:after{content:\"\";position:absolute;top:-11px;left:50%;margin-right:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #fff}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/uploadImage/uploadImage_2.vue"],"names":[],"mappings":"AACA,4CACE,sBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,WAAY,AACZ,YAAc,CACf,AACD,oEACI,WAAY,AAGZ,WAAa,AACb,eAAgB,AAChB,YAAa,AACb,kBAAmB,AACnB,sBAAwB,AACxB,gBAAkB,CACrB,AACD,qDACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,mEACM,uBAAwB,AACxB,eAAgB,AAChB,gBAAiB,AACjB,WAAe,AACf,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,gBAAiB,AACjB,gBAAkB,CACvB,AACD,uDACM,aAAe,CACpB,AACD,2DACM,WAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,kBAAmB,AACnB,uBAAwB,AACxB,eAAgB,AAChB,eAAkB,CACvB,AACD,qDACI,gBAAiB,AACjB,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,WAAa,AACb,kBAAmB,AACnB,aAAc,AACd,UAAY,CACf,AACD,4DACM,WAAY,AACZ,mBAAoB,AACpB,kBAAmB,AACnB,OAAQ,AACR,QAAS,AACT,WAAY,AACZ,UAAY,CACjB,AACD,2DACM,gBAAiB,AACjB,eAAgB,AAChB,qCAAsC,AACtC,kBAAmB,AACnB,kBAAmB,AACnB,qBAAsB,AACtB,2BAA8B,AAC9B,6BAA8B,AAC9B,uCAAwC,AACxC,+BAAgC,AAChC,eAAgB,AAChB,kBAAmB,AACnB,cAAe,AACf,wBAA0B,CAC/B,AACD,6DACI,mBAAoB,AACpB,WAAY,AACZ,iBAAmB,CACtB,AACD,+EACM,gBAAiB,AACjB,kBAAmB,AACnB,QAAS,AACT,QAAS,AACT,aAAe,CACpB,AACD,mFACM,MAAO,AACP,QAAS,AACT,iBAAmB,CACxB,AACD,4EACM,QAAS,AACT,QAAS,AACT,iBAAmB,CACxB,AACD,0EACM,eAAgB,AAChB,WAAa,AACb,gBAAiB,AACjB,uBAAwB,AACxB,eAAgB,AAChB,eAAiB,CACtB,AACD,yBACA,0EACU,aAAe,CACxB,CACA,AACD,6EACM,WAAY,AACZ,YAAa,AACb,YAAc,CACnB,AACD,yGACQ,aAAe,CACtB,AAID,yMACQ,aAAe,CACtB,AACD,2FACQ,aAAe,CACtB,AACD,mFACM,iBAAmB,AACnB,eAAiB,CACtB,AACD,yEACI,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,iBAAmB,CACtB,AACD,oFACM,kBAAmB,AACnB,OAAQ,AACR,OAAS,CACd,AACD,4FACM,UAAW,AACX,iBAAkB,AAClB,kBAAmB,AACnB,eAAiB,CACtB,AACD,iFACM,iBAAkB,AAClB,kBAAmB,AACnB,UAAW,AACX,QAAS,AACT,UAAW,AACX,mBAAsB,AACtB,UAAY,CACjB,AACD,uEACI,cAAoB,CACvB,AACD,0FACM,WAAY,AACZ,gBAAiB,AACjB,aAAc,AACd,sBAAuB,AACpB,kBAAoB,CAC5B,AACD,uGACM,WAAY,AAOZ,WAAa,CAClB,AACD,qNARM,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAUrC,AACD,+HACQ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,eAAiB,CACxB,AACD,0CACA,+HACY,cAAgB,CAC3B,CACA,AAWD,+IACU,iBAAkB,AAClB,uBAAwB,AACxB,eAAgB,AAChB,uBAA0B,CACnC,AACD,mJACU,kBAAmB,AACnB,gBAAkB,CAC3B,AACD,gJACU,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,mBAAoB,AACpB,eAAgB,AAChB,eAAgB,AAChB,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAkB,CAC3B,AACD,sJACU,kBAAmB,AACnB,UAAW,AACX,eAAgB,AAChB,SAAU,AACV,OAAS,CAClB,AACD,gJACU,kBAAmB,AACnB,MAAO,AACP,QAAS,AACT,YAAa,AACb,WAAY,AACZ,sBAAuB,AACvB,cAAgB,CACzB,AACD,uKACU,qBAAuB,CAChC,AACD,yKACU,wBAA0B,CACnC,AACD,sJACU,WAAY,AACZ,kBAAmB,AACnB,YAAc,CACvB,AACD,+KACU,aAAe,CACxB,AACD,iKACU,SAAU,AACV,QAAS,AACT,UAAW,AACX,YAAa,AACb,kBAAoB,AACpB,yBAA0B,AAC1B,gCAAiC,AACjC,uBAAyB,CAClC,AACD,0FACM,kBAAmB,AACnB,eAAiB,CACtB,AACD,yGACQ,uBAAwB,AACxB,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CACtB,AACD,6GACQ,WAAY,AACZ,aAAc,AACd,YAAa,AACb,uBAAwB,AACxB,eAAgB,AAChB,kBAAmB,AACnB,oBAAqB,AACrB,mBAAoB,AACpB,sBAAuB,AACvB,cAAe,AACf,YAAa,AACb,YAAa,AACb,mCAA6C,CACpD,AACD,wIACQ,aAAe,CACtB,AAID,uQACQ,aAAe,CACtB,AACD,0HACQ,aAAe,CACtB,AACD,kEACI,iBAAmB,AACnB,gBAAiB,AACjB,UAAe,CAClB,AACD,29BAgBI,cAAgB,CACnB,AACD,sEACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,uBAAwB,AACxB,cAAgB,CACnB,AACD,4EACM,kBAAoB,AACpB,kBAAqB,CAC1B,AACD,kEACI,oCAA6C,AAC7C,uBAAwB,AACxB,yBAA2B,AAC3B,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,UAAY,CACf,AACD,6FACM,aAAe,CACpB,AACD,gEACI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,8EACM,aAAc,AACd,yBAA0B,AAC1B,WAAe,AACf,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,uBAAwB,AACxB,eAAgB,AAChB,eAAkB,CACvB,AACD,+FACQ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACrB,AACD,uFACQ,eAAgB,AAChB,uBAAwB,AACxB,wBAA2B,CAClC,AACD,kFACM,yBAA0B,AAC1B,WAAe,AACf,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,uBAAwB,AACxB,eAAgB,AAChB,eAAkB,CACvB,AACD,mGACQ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACrB,AACD,2EACI,uBAAwB,AACxB,eAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,UAAa,CAChB,AACD,6DACI,0BAA4B,AAC5B,uBAAwB,AACxB,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,aAAe,CAClB,AACD,iEACI,0BAA4B,AAC5B,uBAAwB,AACxB,eAAgB,AAChB,YAAa,AACb,UAAW,AACX,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,cAAgB,CACnB,AACD,mEACI,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,cAAgB,CACvB,AACD,gGACM,uBAAwB,AACxB,eAAgB,AAChB,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,kBAAmB,AACnB,mCAA6C,CAClD,AACD,uGACQ,sBAAyB,CAChC,AACD,8FACM,uBAAwB,AACxB,eAAgB,AAChB,WAAe,AACf,sBAA0B,AAC1B,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,iBAAmB,CACxB,AACD,qGACQ,sBAAyB,CAChC,AACD,oDACE,WAAa,CACd,AACD,oEACI,mBAAqB,AACrB,aAAe,AACf,WAAY,AACZ,eAAgB,AAChB,aAAc,AACd,sBAA0B,AAC1B,WAAe,AACf,wBAA0B,CAC7B,AACD,+CACE,cAAe,AACf,UAAa,CACd,AACD,wDACI,oBAAqB,AACrB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,0DACM,aAAe,CACpB,AACD,8DACM,gBAAiB,AACjB,gBAAiB,AACjB,mBAAqB,AACrB,aAAe,AACf,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,aAAc,AACd,yBAA0B,AAC1B,WAAe,AACf,qBAA0B,CAC/B,AACD,qDACI,kBAAmB,AACnB,eAAiB,CACpB,AACD,gDACE,mBAAoB,AACpB,mBAAoB,AACpB,2BAAgC,AAChC,8BAAmC,AACnC,iBAAmB,CACpB,AACD,oEACI,uBAAwB,AACxB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,SAAW,CACd,AACD,8DACI,SAAU,AACV,SAAU,AACV,kBAAmB,AACnB,kBAAqB,AACrB,yBAA0B,AAC1B,aAAe,CAClB,AACD,wEACI,eAAgB,AAChB,SAAU,AACV,kBAAmB,AACnB,mBAAqB,AACrB,UAAW,AACX,sBAA0B,AAC1B,WAAe,AACf,aAAc,AACd,mBAAqB,AACrB,yBAA0B,AAC1B,gBAAmB,CACtB,AACD,sEACI,iBAAmB,CACtB,AACD,oFACM,kBAAmB,AACnB,eAAiB,AACjB,aAAe,CACpB,AACD,6FACQ,WAAY,AACZ,eAAgB,AAChB,aAAc,AACd,YAAc,CACrB,AACD,iGAEI,cAAe,AACf,SAAW,CAEd,AAOD,yLAEI,cAAe,AACf,SAAW,CAEd,AACD,mFAEI,cAAe,AACf,SAAW,CAEd,AACD,0FACI,UAAW,AACX,kBAAoB,AACpB,mBAAqB,AACrB,sBAAuB,AACvB,sBAAwB,AACxB,WAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,yBAA2B,CAC9B,AACD,4FACM,kBAAmB,AACnB,WAAa,AACb,cAAe,AACf,QAAW,CAChB,AACD,qDACE,wBAA2B,CAC5B,AACD,sEACI,cAAe,AACf,aAAe,CAClB,AACD,4EACI,gBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACvC,AACD,0EACI,UAAW,AACX,kBAAoB,AACpB,mBAAqB,AACrB,sBAAuB,AACvB,yBAA0B,AAC1B,cAAe,AACf,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,yBAA2B,CAC9B,AACD,4EACM,kBAAmB,AACnB,WAAa,AACb,cAAe,AACf,QAAW,CAChB,AACD,4EACI,UAAW,AACX,kBAAoB,AACpB,mBAAqB,AACrB,sBAAuB,AACvB,yBAA0B,AAC1B,WAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,yBAA2B,CAC9B,AACD,8EACM,kBAAmB,AACnB,WAAa,AACb,cAAe,AACf,QAAW,CAChB,AACD,0BACE,kBAAmB,AACnB,qBAAsB,AACtB,6BAAgC,CACjC,AACD,uCACE,gBAAiB,AACjB,sBAAwB,AACxB,uBAA0B,AAC1B,kBAAmB,AACnB,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,aAAc,AACd,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,OAAQ,AACR,kBAAmB,AACnB,UAAW,AACX,+BAAiC,AACjC,sBAAyB,CAC1B,AACD,8CACE,WAAY,AACZ,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,kBAAmB,AACnB,iBAAkB,AAClB,mBAAoB,AACpB,yCAAuD,CACxD,AACD,6CACE,SAAW,CACZ,AACD,gCACE,0CAAoD,CACrD,AACD,iCACE,kBAAoB,CACrB,AACD,8BACE,eAAiB,CAClB,AACD,wBACE,YAAa,AACb,WAAY,AACZ,oBAAuB,CACxB,AACD,4BACE,uBAAyB,AACzB,kBAAmB,AACnB,6BAA8B,AAC9B,aAAc,AACd,UAAY,CACb,AACD,2CACI,4BAA8B,AAC9B,uBAAyB,AACzB,MAAO,AAEP,wBAAyB,AACjB,gBAAiB,AACzB,4CAAkD,AAClD,mCAAoC,AACpC,iCAAmC,CACtC,AACD,sCACI,6FAAqG,AAGrG,kBAAmB,AACnB,iBAAkB,AAElB,2BAAmB,CAEtB,AACD,+DACI,aAAc,AACd,eAAiB,CACpB,AACD,4CACI,wBAA4B,CAC/B,AACD,4CACI,eAAkB,CACrB,AACD,6DACI,YAAc,CACjB,AACD,oCACE,cAAgB,CACjB,AACD,uBACE,kBAAoB,CACrB,AACD,wBACE,iBAAmB,CACpB,AACD,kCACE,sBAAuB,AACpB,kBAAoB,CACxB,AACD,6BACE,kBAAmB,AACnB,WAAY,AACZ,QAAU,CACX,AACD,iCACE,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,sBAA0B,AAC1B,WAAe,AACf,UAAW,AACX,sBAAwB,CACzB,AACD,0CACE,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,WAAa,AACb,uBAAwB,AACxB,yBAA0B,AAC1B,aAAe,CAChB,AACD,8BACE,aAAc,AACd,uCAA0C,AAC1C,UAAY,CACb,AACD,uCACE,kBAAmB,AACnB,YAAa,AACb,UAAY,CACb,AACD,sCACE,OAAQ,AACR,WAAY,AACZ,kBAAmB,AACnB,YAAc,CACf,AACD,gCACE,eAAgB,AAChB,gBAAiB,AACjB,WAAY,AACZ,sBAAwB,AACxB,WAAe,AACf,eAAiB,AACjB,cAAe,AACf,iBAAmB,CACpB,AACD,kCACE,kBAAmB,AACnB,WAAY,AACZ,UAAW,AACX,OAAQ,AACR,sBAAwB,AACxB,uBAA0B,AAC1B,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,iBAAmB,CACpB,AACD,wCACE,WAAY,AACZ,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,kBAAmB,AACnB,iBAAkB,AAClB,mBAAoB,AACpB,yCAAuD,CACxD","file":"uploadImage_2.vue","sourcesContent":["\n.upload-screen-1-container[data-v-20ab93f1] {\n  background-color: #000000;\n  overflow-y: scroll;\n  height: 100vh;\n  width: 100%;\n  padding: 25px;\n}\n.upload-screen-1-container .add-new-btn-suggestion[data-v-20ab93f1] {\n    width: 90px;\n    background-color: white;\n    color: black;\n    color: black;\n    font-size: 12px;\n    padding: 5px;\n    border-radius: 8px;\n    background-color: white;\n    margin-left: 50px;\n}\n.upload-screen-1-container .actions[data-v-20ab93f1] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.upload-screen-1-container .actions .upload-title[data-v-20ab93f1] {\n      font-family: Montserrat;\n      font-size: 21px;\n      font-weight: 800;\n      color: #ffffff;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      text-align: left;\n      margin-left: 10px;\n}\n.upload-screen-1-container .actions i[data-v-20ab93f1] {\n      font-size: 1em;\n}\n.upload-screen-1-container .actions .done[data-v-20ab93f1] {\n      color: white;\n      font-size: 1.1em;\n      border-radius: 6px;\n      padding: 15px 33px;\n      font-family: Montserrat;\n      font-size: 14px;\n      font-weight: bold;\n}\n.upload-screen-1-container .hr-text[data-v-20ab93f1] {\n    line-height: 1em;\n    position: relative;\n    outline: 0;\n    border: 0;\n    color: black;\n    text-align: center;\n    height: 1.5em;\n    opacity: .5;\n}\n.upload-screen-1-container .hr-text[data-v-20ab93f1]:before {\n      content: '';\n      background: #818078;\n      position: absolute;\n      left: 0;\n      top: 50%;\n      width: 100%;\n      height: 1px;\n}\n.upload-screen-1-container .hr-text[data-v-20ab93f1]:after {\n      margin-top: -6px;\n      font-size: 24px;\n      -webkit-font-feature-settings: 'liga';\n      position: relative;\n      margin-left: -100%;\n      display: inline-block;\n      font-family: 'Material Icons';\n      content: \"keyboard_backspace\";\n      -webkit-font-feature-settings: \"liga\" 1;\n      font-feature-settings: \"liga\" 1;\n      padding: 0 .5em;\n      line-height: 1.5em;\n      color: #818078;\n      background-color: #fcfcfa;\n}\n.upload-screen-1-container .input-container[data-v-20ab93f1] {\n    margin-bottom: 15px;\n    width: 100%;\n    position: relative;\n}\n.upload-screen-1-container .input-container .input-arrow-icon[data-v-20ab93f1] {\n      font-size: 1.1em;\n      position: absolute;\n      right: 0;\n      top: 1em;\n      color: #9b9b9b;\n}\n.upload-screen-1-container .input-container .public-access-toggle[data-v-20ab93f1] {\n      top: 0;\n      right: 0;\n      position: absolute;\n}\n.upload-screen-1-container .input-container .location-icon[data-v-20ab93f1] {\n      top: 20%;\n      right: 0;\n      position: absolute;\n}\n.upload-screen-1-container .input-container .input-label[data-v-20ab93f1] {\n      margin-top: 1em;\n      color: white;\n      text-align: left;\n      font-family: Montserrat;\n      font-size: 12px;\n      font-weight: 800;\n}\n@media (max-width: 330px) {\n.upload-screen-1-container .input-container .input-label[data-v-20ab93f1] {\n          font-size: 1em;\n}\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1] {\n      width: 100%;\n      height: 100%;\n      outline: none;\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1] ::-webkit-input-placeholder {\n        font-size: 1em;\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1] :-ms-input-placeholder {\n        font-size: 1em;\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1] ::-ms-input-placeholder {\n        font-size: 1em;\n}\n.upload-screen-1-container .input-container .img-desc-input[data-v-20ab93f1] ::placeholder {\n        font-size: 1em;\n}\n.upload-screen-1-container .input-container .input-container-text[data-v-20ab93f1] {\n      font-size: 0.857em;\n      text-align: left;\n}\n.upload-screen-1-container .important-details-container[data-v-20ab93f1] {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    position: relative;\n}\n.upload-screen-1-container .important-details-container .back-icon[data-v-20ab93f1] {\n      position: absolute;\n      left: 0;\n      top: 58%;\n}\n.upload-screen-1-container .important-details-container .important-details[data-v-20ab93f1] {\n      width: 98%;\n      text-align: right;\n      font-size: 1.286em;\n      font-weight: 700;\n}\n.upload-screen-1-container .important-details-container .hr-div[data-v-20ab93f1] {\n      margin-left: 20px;\n      position: absolute;\n      width: 90%;\n      top: 58%;\n      left: 20px;\n      background: lightgrey;\n      height: 1px;\n}\n.upload-screen-1-container .img-and-caption-container[data-v-20ab93f1] {\n    margin: 5px 0 0px 0;\n}\n.upload-screen-1-container .img-and-caption-container .img-container img[data-v-20ab93f1] {\n      width: 100%;\n      max-width: 600px;\n      height: 400px;\n      -o-object-fit: contain;\n         object-fit: contain;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .video-container[data-v-20ab93f1] {\n      width: 100%;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      height: 100%;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access[data-v-20ab93f1] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .inner-container[data-v-20ab93f1] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        min-width: 600px;\n}\n@media only screen and (max-width: 1280px) {\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .inner-container[data-v-20ab93f1] {\n            min-width: 100%;\n}\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container[data-v-20ab93f1] {\n        /* The container */\n        /* Hide the browser's default checkbox */\n        /* Create a custom checkbox */\n        /* On mouse-over, add a grey background color */\n        /* When the checkbox is checked, add a blue background */\n        /* Create the checkmark/indicator (hidden when not checked) */\n        /* Show the checkmark when checked */\n        /* Style the checkmark/indicator */\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .sub-text[data-v-20ab93f1] {\n          text-align: right;\n          font-family: Montserrat;\n          font-size: 10px;\n          color: #b9b9b9 !important;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .heading-text[data-v-20ab93f1] {\n          margin-right: 25px;\n          text-align: right;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container[data-v-20ab93f1] {\n          display: block;\n          position: relative;\n          padding-left: 35px;\n          margin-bottom: 12px;\n          cursor: pointer;\n          font-size: 22px;\n          -webkit-user-select: none;\n          -moz-user-select: none;\n          -ms-user-select: none;\n          user-select: none;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container input[data-v-20ab93f1] {\n          position: absolute;\n          opacity: 0;\n          cursor: pointer;\n          height: 0;\n          width: 0;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .checkmark[data-v-20ab93f1] {\n          position: absolute;\n          top: 0;\n          right: 0;\n          height: 18px;\n          width: 18px;\n          background-color: #eee;\n          margin-top: 8px;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container:hover input ~ .checkmark[data-v-20ab93f1] {\n          background-color: #ccc;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container input:checked ~ .checkmark[data-v-20ab93f1] {\n          background-color: #b9b9b9;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .checkmark[data-v-20ab93f1]:after {\n          content: \"\";\n          position: absolute;\n          display: none;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container input:checked ~ .checkmark[data-v-20ab93f1]:after {\n          display: block;\n}\n.upload-screen-1-container .img-and-caption-container .img-container .location-piblic-access .public-spot-container .container .checkmark[data-v-20ab93f1]:after {\n          left: 7px;\n          top: 1px;\n          width: 6px;\n          height: 12px;\n          border: solid black;\n          border-width: 0 3px 3px 0;\n          -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.upload-screen-1-container .img-and-caption-container .caption-container[data-v-20ab93f1] {\n      padding-left: 10px;\n      text-align: left;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-title[data-v-20ab93f1] {\n        font-family: Montserrat;\n        font-size: 21px;\n        font-weight: 500;\n        color: #b9b9b9;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1] {\n        width: 100%;\n        outline: none;\n        resize: none;\n        font-family: Montserrat;\n        font-size: 21px;\n        font-style: normal;\n        font-stretch: normal;\n        line-height: normal;\n        letter-spacing: normal;\n        color: #f5a623;\n        height: 90px;\n        padding: 8px;\n        border: solid 0.2px rgba(185, 185, 185, 0.5);\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1]::-webkit-input-placeholder {\n        color: #5b5b5b;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1]:-ms-input-placeholder {\n        color: #5b5b5b;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1]::-ms-input-placeholder {\n        color: #5b5b5b;\n}\n.upload-screen-1-container .img-and-caption-container .caption-container .caption-text-area[data-v-20ab93f1]::placeholder {\n        color: #5b5b5b;\n}\n.upload-screen-1-container .selected-tags-upload[data-v-20ab93f1] {\n    font-size: 0.939em;\n    font-weight: 500;\n    color: #ffffff;\n}\n.upload-screen-1-container input[type=\"color\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"date\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"datetime\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"datetime-local\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"email\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"month\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"number\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"password\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"search\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"tel\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"text\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"time\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"url\"][data-v-20ab93f1],\n  .upload-screen-1-container input[type=\"week\"][data-v-20ab93f1],\n  .upload-screen-1-container select[data-v-20ab93f1]:focus,\n  .upload-screen-1-container textarea[data-v-20ab93f1] {\n    font-size: 16px;\n}\n.upload-screen-1-container .all-selected-suggestions[data-v-20ab93f1] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    font-family: Montserrat;\n    font-size: 12px;\n}\n.upload-screen-1-container .all-selected-suggestions .tags[data-v-20ab93f1] {\n      margin-right: 0.4em;\n      margin-bottom: 0.4em;\n}\n.upload-screen-1-container .selected-suggestions[data-v-20ab93f1] {\n    border: solid 0.2px rgba(185, 185, 185, 0.5);\n    font-family: Montserrat;\n    font-size: 12px !important;\n    color: #f5a623;\n    padding: 8px;\n    margin-bottom: 5px;\n    width: 100%;\n}\n.upload-screen-1-container .selected-suggestions .selected-tags-placeholder[data-v-20ab93f1] {\n      color: #b9b9b9;\n}\n.upload-screen-1-container .location-container[data-v-20ab93f1] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.upload-screen-1-container .location-container .add-location[data-v-20ab93f1] {\n      outline: none;\n      background-color: #b9b9b9;\n      color: #000000;\n      padding: 5px 17px;\n      border-radius: 6px;\n      position: relative;\n      font-family: Montserrat;\n      font-size: 12px;\n      font-weight: bold;\n}\n.upload-screen-1-container .location-container .add-location .location-button[data-v-20ab93f1] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.upload-screen-1-container .location-container .add-location .address[data-v-20ab93f1] {\n        margin-top: 5px;\n        font-family: Montserrat;\n        font-size: 12px !important;\n}\n.upload-screen-1-container .location-container .add-location-new[data-v-20ab93f1] {\n      background-color: #f5a623;\n      color: #000000;\n      padding: 5px 17px;\n      border-radius: 6px;\n      position: relative;\n      font-family: Montserrat;\n      font-size: 12px;\n      font-weight: bold;\n}\n.upload-screen-1-container .location-container .add-location-new .location-button[data-v-20ab93f1] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n}\n.upload-screen-1-container .image-datetime-upload-heading[data-v-20ab93f1] {\n    font-family: Montserrat;\n    font-size: 12px;\n    font-weight: 500;\n    margin-top: 15px;\n    color: white;\n}\n.upload-screen-1-container .video-input-box[data-v-20ab93f1] {\n    border: solid 0.2px #b9b9b9;\n    font-family: Montserrat;\n    font-size: 12px;\n    min-width: 650px;\n    padding: 5px;\n    color: #f5a623;\n}\n.upload-screen-1-container .date-time-input-box[data-v-20ab93f1] {\n    border: solid 0.2px #b9b9b9;\n    font-family: Montserrat;\n    font-size: 12px;\n    padding: 5px;\n    width: 50%;\n    color: #f5a623;\n    margin-bottom: 10px;\n    margin-right: 10px;\n    cursor: pointer;\n}\n.upload-screen-1-container .suggestions-container[data-v-20ab93f1] {\n    width: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.upload-screen-1-container .suggestions-container .unselected-suggestion-pills[data-v-20ab93f1] {\n      font-family: Montserrat;\n      font-size: 12px;\n      color: #b9b9b9;\n      padding: 5px;\n      border-radius: 8px;\n      margin-right: 10px;\n      margin-bottom: 5px;\n      border: 0.2px solid rgba(185, 185, 185, 0.5);\n}\n.upload-screen-1-container .suggestions-container .unselected-suggestion-pills button[data-v-20ab93f1] {\n        outline: none !important;\n}\n.upload-screen-1-container .suggestions-container .selected-suggestion-pills[data-v-20ab93f1] {\n      font-family: Montserrat;\n      font-size: 12px;\n      color: #000000;\n      background-color: #ffffff;\n      padding: 5px;\n      border-radius: 8px;\n      margin-right: 10px;\n      margin-bottom: 5px;\n}\n.upload-screen-1-container .suggestions-container .selected-suggestion-pills button[data-v-20ab93f1] {\n        outline: none !important;\n}\n.main-container .add-tag-container[data-v-20ab93f1] {\n  padding: 2em;\n}\n.main-container .add-tag-container .tag-add-button[data-v-20ab93f1] {\n    border-radius: 0.5em;\n    padding: 0.3em;\n    width: 100%;\n    margin-top: 2em;\n    outline: none;\n    background-color: #000000;\n    color: #ffffff;\n    border: 1px solid #f5a623;\n}\n.main-container .head-section[data-v-20ab93f1] {\n  padding: 0 1em;\n  color: white;\n}\n.main-container .head-section .actions[data-v-20ab93f1] {\n    padding-top: 1.629em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.main-container .head-section .actions i[data-v-20ab93f1] {\n      font-size: 1em;\n}\n.main-container .head-section .actions .done[data-v-20ab93f1] {\n      font-size: 1.1em;\n      font-weight: 700;\n      border-radius: 0.5em;\n      padding: 0.3em;\n      margin-top: 2em;\n      padding-left: 1em;\n      padding-right: 1em;\n      outline: none;\n      background-color: #bd10e0;\n      color: #ffffff;\n      border: 1px solid #000000;\n}\n.main-container .head-section .head[data-v-20ab93f1] {\n    padding-right: 2em;\n    font-size: 1.1em;\n}\n.main-container .input-section[data-v-20ab93f1] {\n  min-height: 5.643em;\n  margin-top: 1.857em;\n  border-top: 0.5px solid #000000;\n  border-bottom: 0.5px solid #000000;\n  position: relative;\n}\n.main-container .input-section .clickable-modal-bg[data-v-20ab93f1] {\n    background: transparent;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n}\n.main-container .input-section .input-header[data-v-20ab93f1] {\n    left: 1em;\n    top: -1em;\n    position: absolute;\n    padding: 0.3em 0.5em;\n    background-color: #4a4a4a;\n    color: #9b9b9b;\n}\n.main-container .input-section .add-new-btn-suggestion[data-v-20ab93f1] {\n    cursor: pointer;\n    top: -1em;\n    position: absolute;\n    padding: 0.3em 1.2em;\n    right: 1em;\n    background-color: #000000;\n    color: #ffffff;\n    outline: none;\n    border-radius: 0.5em;\n    border: 1px solid #9b9b9b;\n    font-size: 0.857em;\n}\n.main-container .input-section .selected-suggestions[data-v-20ab93f1] {\n    padding: 1.5em 1em;\n}\n.main-container .input-section .selected-suggestions .default-text[data-v-20ab93f1] {\n      text-align: center;\n      font-size: 0.9em;\n      color: #f5a623;\n}\n.main-container .input-section .selected-suggestions .default-text textarea[data-v-20ab93f1] {\n        width: 100%;\n        font-size: 16px;\n        outline: none;\n        resize: unset;\n}\n.main-container .input-section .selected-suggestions[data-v-20ab93f1]::-webkit-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .selected-suggestions[data-v-20ab93f1]:-ms-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .selected-suggestions[data-v-20ab93f1]::-ms-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .selected-suggestions[data-v-20ab93f1]::placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .suggestions-container .added-suggestions[data-v-20ab93f1] {\n    z-index: 4;\n    margin-right: 0.8em;\n    margin-bottom: 0.4em;\n    padding: 0 2.5em 0 1em;\n    background-color: black;\n    color: white;\n    border: 1px solid #f5a623;\n    position: relative;\n    outline: none;\n    text-transform: capitalize;\n}\n.main-container .input-section .suggestions-container .added-suggestions i[data-v-20ab93f1] {\n      position: absolute;\n      right: 0.5em;\n      font-size: 1em;\n      top: 0.2em;\n}\n.main-container .suggestion-section[data-v-20ab93f1] {\n  padding: 1.5em 0.5em 0 1em;\n}\n.main-container .suggestion-section .suggestion-head[data-v-20ab93f1] {\n    font-size: 1em;\n    color: #9b9b9b;\n}\n.main-container .suggestion-section .suggestions-container[data-v-20ab93f1] {\n    margin-top: 0.5em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.main-container .suggestion-section .selected-suggestion[data-v-20ab93f1] {\n    z-index: 4;\n    margin-right: 0.8em;\n    margin-bottom: 0.4em;\n    padding: 0 2.5em 0 1em;\n    background-color: #9b9b9b;\n    color: #4a4a4a;\n    border: 1px solid #9b9b9b;\n    position: relative;\n    outline: none;\n    text-transform: capitalize;\n}\n.main-container .suggestion-section .selected-suggestion i[data-v-20ab93f1] {\n      position: absolute;\n      right: 0.5em;\n      font-size: 1em;\n      top: 0.2em;\n}\n.main-container .suggestion-section .unselected-suggestion[data-v-20ab93f1] {\n    z-index: 4;\n    margin-right: 0.8em;\n    margin-bottom: 0.4em;\n    padding: 0 2.5em 0 1em;\n    background-color: #4a4a4a;\n    color: white;\n    border: 1px solid #9b9b9b;\n    position: relative;\n    outline: none;\n    text-transform: capitalize;\n}\n.main-container .suggestion-section .unselected-suggestion i[data-v-20ab93f1] {\n      position: absolute;\n      right: 0.5em;\n      font-size: 1em;\n      top: 0.2em;\n}\n.tooltip[data-v-20ab93f1] {\n  position: relative;\n  display: inline-block;\n  border-bottom: 1px dotted black;\n}\n.tooltip .tooltiptext[data-v-20ab93f1] {\n  max-width: 300px;\n  background-color: black;\n  border: 0.2px solid white;\n  border-radius: 5px;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 10px;\n  position: absolute;\n  z-index: 1;\n  top: 110%;\n  left: 0;\n  margin-left: -60px;\n  opacity: 0;\n  -webkit-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n}\n.tooltip .tooltiptext[data-v-20ab93f1]::before {\n  content: \"\";\n  position: absolute;\n  top: -11px;\n  left: 50%;\n  margin-right: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent #fff transparent;\n}\n.tooltip:hover .tooltiptext[data-v-20ab93f1] {\n  opacity: 1;\n}\n.border-bottom[data-v-20ab93f1] {\n  border-bottom: solid 0.5px rgba(155, 155, 155, 0.5);\n}\n.padding-bottom[data-v-20ab93f1] {\n  padding-bottom: 1em;\n}\n.padding-top[data-v-20ab93f1] {\n  padding-top: 1em;\n}\n#myMap[data-v-20ab93f1] {\n  height: 60vh;\n  width: 100%;\n  z-index: 10 !important;\n}\n#pac-input[data-v-20ab93f1] {\n  z-index: 1000 !important;\n  position: relative;\n  padding: 10px 3.5em 10px 10px;\n  outline: none;\n  width: 100%;\n}\n#pac-input .pac-container[data-v-20ab93f1] {\n    position: absolute !important;\n    z-index: 1000 !important;\n    top: 0;\n    /*display: block!important;*/\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    font-family: \"Lato\", Helvetica, Arial, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n#pac-input .pac-item[data-v-20ab93f1] {\n    background: transparent url(\"https://png.icons8.com/ios/22/000000/marker.png\") no-repeat 22px center;\n    padding-top: 15px;\n    padding-right: 25px;\n    position: relative;\n    line-height: 20px;\n    padding-bottom: 15px;\n    padding-left: 65px;\n    /* border: none; */\n}\n#pac-input .pac-item span[data-v-20ab93f1]:nth-child(3)::before {\n    content: \"\\A\";\n    white-space: pre;\n}\n#pac-input .pac-item[data-v-20ab93f1]:hover {\n    background-color: lightgrey;\n}\n#pac-input .pac-item-query[data-v-20ab93f1] {\n    font-weight: bold;\n}\n#pac-input div.pac-container.pac-logo[data-v-20ab93f1]::after {\n    display: none;\n}\n.search-loc-loc-me[data-v-20ab93f1] {\n  margin-top: 5px;\n}\n.true[data-v-20ab93f1] {\n  visibility: visible;\n}\n.false[data-v-20ab93f1] {\n  visibility: hidden;\n}\n.image-thumbnail[data-v-20ab93f1] {\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n.my-loc-btn[data-v-20ab93f1] {\n  position: absolute;\n  right: 20px;\n  top: 10px;\n}\n.select-loc-btn[data-v-20ab93f1] {\n  width: 100%;\n  padding: 10px 20px;\n  text-align: center;\n  background-color: #000000;\n  color: #ffffff;\n  opacity: 1;\n  font-family: Montserrat;\n}\n.select-loc-btn-disabled[data-v-20ab93f1] {\n  width: 100%;\n  padding: 10px 20px;\n  text-align: center;\n  opacity: 0.9;\n  font-family: Montserrat;\n  background-color: #5b5b5b;\n  color: #9b9b9b;\n}\n.travel-info[data-v-20ab93f1] {\n  outline: none;\n  border-bottom: 1px solid white !important;\n  width: 100%;\n}\n.video-player-youtube[data-v-20ab93f1] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.share-btn-container[data-v-20ab93f1] {\n  left: 0;\n  width: 100%;\n  position: absolute;\n  bottom: 1.5em;\n}\n.share-img-btn[data-v-20ab93f1] {\n  margin-top: 2em;\n  max-width: 270px;\n  width: 100%;\n  background-color: black;\n  color: #ffffff;\n  font-size: 0.9em;\n  line-height: 2;\n  border-radius: 6px;\n}\n.map-tooltiptext[data-v-20ab93f1] {\n  position: absolute;\n  z-index: 10;\n  top: -35px;\n  left: 0;\n  background-color: black;\n  border: 0.2px solid white;\n  border-radius: 5px;\n  color: #fff;\n  padding: 5px;\n  text-align: center;\n}\n.map-tooltiptext[data-v-20ab93f1]::after {\n  content: \"\";\n  position: absolute;\n  top: -11px;\n  left: 50%;\n  margin-right: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent #fff transparent;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".main-container .add-tag-container[data-v-a58d1328]{padding:2em}.main-container .add-tag-container .tag-add-button[data-v-a58d1328]{border-radius:.5em;padding:.3em;width:100%;margin-top:2em;outline:none;background-color:#000;color:#fff;border:1px solid #f5a623}.main-container .head-section[data-v-a58d1328]{padding:0 1em;color:#fff}.main-container .head-section .actions[data-v-a58d1328]{padding-top:1.629em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.main-container .head-section .actions i[data-v-a58d1328]{font-size:1em}.main-container .head-section .actions .done[data-v-a58d1328]{font-size:1.1em;font-weight:700;border-radius:.5em;padding:.3em;margin-top:2em;padding-left:1em;padding-right:1em;outline:none;background-color:#bd10e0;color:#fff;border:1px solid #000}.main-container .head-section .head[data-v-a58d1328]{padding-right:2em;font-size:1.1em}.main-container .input-section[data-v-a58d1328]{min-height:5.643em;margin-top:1.857em;border-top:.5px solid #000;border-bottom:.5px solid #000;position:relative}.main-container .input-section .clickable-modal-bg[data-v-a58d1328]{background:transparent;position:absolute;width:100%;height:100%;z-index:1}.main-container .input-section .input-header[data-v-a58d1328]{left:1em;top:-1em;position:absolute;padding:.3em .5em;background-color:#4a4a4a;color:#9b9b9b}.main-container .input-section .add-new-btn-suggestion[data-v-a58d1328]{cursor:pointer;top:-1em;position:absolute;padding:.3em 1.2em;right:1em;background-color:#000;color:#fff;outline:none;border-radius:.5em;border:1px solid #9b9b9b;font-size:.857em}.main-container .input-section .selected-suggestions[data-v-a58d1328]{padding:1.5em 1em}.main-container .input-section .selected-suggestions .default-text[data-v-a58d1328]{text-align:center;font-size:.9em;color:#f5a623}.main-container .input-section .selected-suggestions .default-text textarea[data-v-a58d1328]{width:100%;font-size:16px;outline:none;resize:unset}.main-container .input-section .selected-suggestions[data-v-a58d1328]::-webkit-input-placeholder{color:#b9b9b9;opacity:1}.main-container .input-section .selected-suggestions[data-v-a58d1328]:-ms-input-placeholder,.main-container .input-section .selected-suggestions[data-v-a58d1328]::-ms-input-placeholder{color:#b9b9b9;opacity:1}.main-container .input-section .selected-suggestions[data-v-a58d1328]::placeholder{color:#b9b9b9;opacity:1}.main-container .input-section .suggestions-container .added-suggestions[data-v-a58d1328]{z-index:4;margin-right:.8em;margin-bottom:.4em;padding:0 2.5em 0 1em;background-color:#000;color:#fff;border:1px solid #f5a623;position:relative;outline:none;text-transform:capitalize}.main-container .input-section .suggestions-container .added-suggestions i[data-v-a58d1328]{position:absolute;right:.5em;font-size:1em;top:.2em}.main-container .suggestion-section[data-v-a58d1328]{padding:1.5em .5em 0 1em}.main-container .suggestion-section .suggestion-head[data-v-a58d1328]{font-size:1em;color:#9b9b9b}.main-container .suggestion-section .suggestions-container[data-v-a58d1328]{margin-top:.5em;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.main-container .suggestion-section .selected-suggestion[data-v-a58d1328]{z-index:4;margin-right:.8em;margin-bottom:.4em;padding:0 2.5em 0 1em;background-color:#9b9b9b;color:#4a4a4a;border:1px solid #9b9b9b;position:relative;outline:none;text-transform:capitalize}.main-container .suggestion-section .selected-suggestion i[data-v-a58d1328]{position:absolute;right:.5em;font-size:1em;top:.2em}.main-container .suggestion-section .unselected-suggestion[data-v-a58d1328]{z-index:4;margin-right:.8em;margin-bottom:.4em;padding:0 2.5em 0 1em;background-color:#4a4a4a;color:#fff;border:1px solid #9b9b9b;position:relative;outline:none;text-transform:capitalize}.main-container .suggestion-section .unselected-suggestion i[data-v-a58d1328]{position:absolute;right:.5em;font-size:1em;top:.2em}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/uploadImage/suggestion-model.vue"],"names":[],"mappings":"AACA,oDACE,WAAa,CACd,AACD,oEACI,mBAAqB,AACrB,aAAe,AACf,WAAY,AACZ,eAAgB,AAChB,aAAc,AACd,sBAA0B,AAC1B,WAAe,AACf,wBAA0B,CAC7B,AACD,+CACE,cAAe,AACf,UAAa,CACd,AACD,wDACI,oBAAqB,AACrB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,0DACM,aAAe,CACpB,AACD,8DACM,gBAAiB,AACjB,gBAAiB,AACjB,mBAAqB,AACrB,aAAe,AACf,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,aAAc,AACd,yBAA0B,AAC1B,WAAe,AACf,qBAA0B,CAC/B,AACD,qDACI,kBAAmB,AACnB,eAAiB,CACpB,AACD,gDACE,mBAAoB,AACpB,mBAAoB,AACpB,2BAAgC,AAChC,8BAAmC,AACnC,iBAAmB,CACpB,AACD,oEACI,uBAAwB,AACxB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,SAAW,CACd,AACD,8DACI,SAAU,AACV,SAAU,AACV,kBAAmB,AACnB,kBAAqB,AACrB,yBAA0B,AAC1B,aAAe,CAClB,AACD,wEACI,eAAgB,AAChB,SAAU,AACV,kBAAmB,AACnB,mBAAqB,AACrB,UAAW,AACX,sBAA0B,AAC1B,WAAe,AACf,aAAc,AACd,mBAAqB,AACrB,yBAA0B,AAC1B,gBAAmB,CACtB,AACD,sEACI,iBAAmB,CACtB,AACD,oFACM,kBAAmB,AACnB,eAAiB,AACjB,aAAe,CACpB,AACD,6FACQ,WAAY,AACZ,eAAgB,AAChB,aAAc,AACd,YAAc,CACrB,AACD,iGAEI,cAAe,AACf,SAAW,CAEd,AAOD,yLAEI,cAAe,AACf,SAAW,CAEd,AACD,mFAEI,cAAe,AACf,SAAW,CAEd,AACD,0FACI,UAAW,AACX,kBAAoB,AACpB,mBAAqB,AACrB,sBAAuB,AACvB,sBAAwB,AACxB,WAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,yBAA2B,CAC9B,AACD,4FACM,kBAAmB,AACnB,WAAa,AACb,cAAe,AACf,QAAW,CAChB,AACD,qDACE,wBAA2B,CAC5B,AACD,sEACI,cAAe,AACf,aAAe,CAClB,AACD,4EACI,gBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACvC,AACD,0EACI,UAAW,AACX,kBAAoB,AACpB,mBAAqB,AACrB,sBAAuB,AACvB,yBAA0B,AAC1B,cAAe,AACf,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,yBAA2B,CAC9B,AACD,4EACM,kBAAmB,AACnB,WAAa,AACb,cAAe,AACf,QAAW,CAChB,AACD,4EACI,UAAW,AACX,kBAAoB,AACpB,mBAAqB,AACrB,sBAAuB,AACvB,yBAA0B,AAC1B,WAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,yBAA2B,CAC9B,AACD,8EACM,kBAAmB,AACnB,WAAa,AACb,cAAe,AACf,QAAW,CAChB","file":"suggestion-model.vue","sourcesContent":["\n.main-container .add-tag-container[data-v-a58d1328] {\n  padding: 2em;\n}\n.main-container .add-tag-container .tag-add-button[data-v-a58d1328] {\n    border-radius: 0.5em;\n    padding: 0.3em;\n    width: 100%;\n    margin-top: 2em;\n    outline: none;\n    background-color: #000000;\n    color: #ffffff;\n    border: 1px solid #f5a623;\n}\n.main-container .head-section[data-v-a58d1328] {\n  padding: 0 1em;\n  color: white;\n}\n.main-container .head-section .actions[data-v-a58d1328] {\n    padding-top: 1.629em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.main-container .head-section .actions i[data-v-a58d1328] {\n      font-size: 1em;\n}\n.main-container .head-section .actions .done[data-v-a58d1328] {\n      font-size: 1.1em;\n      font-weight: 700;\n      border-radius: 0.5em;\n      padding: 0.3em;\n      margin-top: 2em;\n      padding-left: 1em;\n      padding-right: 1em;\n      outline: none;\n      background-color: #bd10e0;\n      color: #ffffff;\n      border: 1px solid #000000;\n}\n.main-container .head-section .head[data-v-a58d1328] {\n    padding-right: 2em;\n    font-size: 1.1em;\n}\n.main-container .input-section[data-v-a58d1328] {\n  min-height: 5.643em;\n  margin-top: 1.857em;\n  border-top: 0.5px solid #000000;\n  border-bottom: 0.5px solid #000000;\n  position: relative;\n}\n.main-container .input-section .clickable-modal-bg[data-v-a58d1328] {\n    background: transparent;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n}\n.main-container .input-section .input-header[data-v-a58d1328] {\n    left: 1em;\n    top: -1em;\n    position: absolute;\n    padding: 0.3em 0.5em;\n    background-color: #4a4a4a;\n    color: #9b9b9b;\n}\n.main-container .input-section .add-new-btn-suggestion[data-v-a58d1328] {\n    cursor: pointer;\n    top: -1em;\n    position: absolute;\n    padding: 0.3em 1.2em;\n    right: 1em;\n    background-color: #000000;\n    color: #ffffff;\n    outline: none;\n    border-radius: 0.5em;\n    border: 1px solid #9b9b9b;\n    font-size: 0.857em;\n}\n.main-container .input-section .selected-suggestions[data-v-a58d1328] {\n    padding: 1.5em 1em;\n}\n.main-container .input-section .selected-suggestions .default-text[data-v-a58d1328] {\n      text-align: center;\n      font-size: 0.9em;\n      color: #f5a623;\n}\n.main-container .input-section .selected-suggestions .default-text textarea[data-v-a58d1328] {\n        width: 100%;\n        font-size: 16px;\n        outline: none;\n        resize: unset;\n}\n.main-container .input-section .selected-suggestions[data-v-a58d1328]::-webkit-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .selected-suggestions[data-v-a58d1328]:-ms-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .selected-suggestions[data-v-a58d1328]::-ms-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .selected-suggestions[data-v-a58d1328]::placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .suggestions-container .added-suggestions[data-v-a58d1328] {\n    z-index: 4;\n    margin-right: 0.8em;\n    margin-bottom: 0.4em;\n    padding: 0 2.5em 0 1em;\n    background-color: black;\n    color: white;\n    border: 1px solid #f5a623;\n    position: relative;\n    outline: none;\n    text-transform: capitalize;\n}\n.main-container .input-section .suggestions-container .added-suggestions i[data-v-a58d1328] {\n      position: absolute;\n      right: 0.5em;\n      font-size: 1em;\n      top: 0.2em;\n}\n.main-container .suggestion-section[data-v-a58d1328] {\n  padding: 1.5em 0.5em 0 1em;\n}\n.main-container .suggestion-section .suggestion-head[data-v-a58d1328] {\n    font-size: 1em;\n    color: #9b9b9b;\n}\n.main-container .suggestion-section .suggestions-container[data-v-a58d1328] {\n    margin-top: 0.5em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.main-container .suggestion-section .selected-suggestion[data-v-a58d1328] {\n    z-index: 4;\n    margin-right: 0.8em;\n    margin-bottom: 0.4em;\n    padding: 0 2.5em 0 1em;\n    background-color: #9b9b9b;\n    color: #4a4a4a;\n    border: 1px solid #9b9b9b;\n    position: relative;\n    outline: none;\n    text-transform: capitalize;\n}\n.main-container .suggestion-section .selected-suggestion i[data-v-a58d1328] {\n      position: absolute;\n      right: 0.5em;\n      font-size: 1em;\n      top: 0.2em;\n}\n.main-container .suggestion-section .unselected-suggestion[data-v-a58d1328] {\n    z-index: 4;\n    margin-right: 0.8em;\n    margin-bottom: 0.4em;\n    padding: 0 2.5em 0 1em;\n    background-color: #4a4a4a;\n    color: white;\n    border: 1px solid #9b9b9b;\n    position: relative;\n    outline: none;\n    text-transform: capitalize;\n}\n.main-container .suggestion-section .unselected-suggestion i[data-v-a58d1328] {\n      position: absolute;\n      right: 0.5em;\n      font-size: 1em;\n      top: 0.2em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".main-container .add-tag-container[data-v-ef69b936]{padding:2em}.main-container .add-tag-container .tag-add-button[data-v-ef69b936]{border-radius:.5em;padding:.3em;width:100%;margin-top:2em;outline:none;background-color:#000;color:#fff;border:1px solid #f5a623}.main-container .head-section[data-v-ef69b936]{padding:0 1em;color:#fff}.main-container .head-section .actions[data-v-ef69b936]{padding-top:1.629em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.main-container .head-section .actions i[data-v-ef69b936]{font-size:1em}.main-container .head-section .actions .done[data-v-ef69b936]{font-size:1.1em;font-weight:700;border-radius:.5em;padding:.3em;margin-top:2em;padding-left:1em;padding-right:1em;outline:none;background-color:#bd10e0;color:#fff;border:1px solid #000}.main-container .head-section .head[data-v-ef69b936]{padding-right:2em;font-size:1.1em}.main-container .input-section[data-v-ef69b936]{min-height:5.643em;margin-top:1.857em;border-top:.5px solid #000;border-bottom:.5px solid #000;position:relative}.main-container .input-section .clickable-modal-bg[data-v-ef69b936]{background:transparent;position:absolute;width:100%;height:100%;z-index:1}.main-container .input-section .input-header[data-v-ef69b936]{left:1em;top:-1em;position:absolute;padding:.3em .5em;background-color:#4a4a4a;color:#9b9b9b}.main-container .input-section .add-new-btn-suggestion[data-v-ef69b936]{cursor:pointer;top:-1em;position:absolute;padding:.3em 1.2em;right:1em;background-color:#000;color:#fff;outline:none;border-radius:.5em;border:1px solid #9b9b9b;font-size:.857em}.main-container .input-section .selected-suggestions[data-v-ef69b936]{padding:1.5em 1em}.main-container .input-section .selected-suggestions .default-text[data-v-ef69b936]{text-align:center;font-size:.9em;color:#f5a623}.main-container .input-section .selected-suggestions .default-text textarea[data-v-ef69b936]{width:100%;font-size:16px;outline:none;resize:unset}.main-container .input-section .selected-suggestions[data-v-ef69b936]::-webkit-input-placeholder{color:#b9b9b9;opacity:1}.main-container .input-section .selected-suggestions[data-v-ef69b936]:-ms-input-placeholder,.main-container .input-section .selected-suggestions[data-v-ef69b936]::-ms-input-placeholder{color:#b9b9b9;opacity:1}.main-container .input-section .selected-suggestions[data-v-ef69b936]::placeholder{color:#b9b9b9;opacity:1}.main-container .input-section .suggestions-container .added-suggestions[data-v-ef69b936]{z-index:4;margin-right:.8em;margin-bottom:.4em;padding:0 2.5em 0 1em;background-color:#000;color:#fff;border:1px solid #f5a623;position:relative;outline:none;text-transform:capitalize}.main-container .input-section .suggestions-container .added-suggestions i[data-v-ef69b936]{position:absolute;right:.5em;font-size:1em;top:.2em}.main-container .suggestion-section[data-v-ef69b936]{padding:1.5em .5em 0 1em}.main-container .suggestion-section .suggestion-head[data-v-ef69b936]{font-size:1em;color:#9b9b9b}.main-container .suggestion-section .suggestions-container[data-v-ef69b936]{margin-top:.5em;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.main-container .suggestion-section .selected-suggestion[data-v-ef69b936]{z-index:4;margin-right:.8em;margin-bottom:.4em;padding:0 2.5em 0 1em;background-color:#9b9b9b;color:#4a4a4a;border:1px solid #9b9b9b;position:relative;outline:none;text-transform:capitalize}.main-container .suggestion-section .selected-suggestion i[data-v-ef69b936]{position:absolute;right:.5em;font-size:1em;top:.2em}.main-container .suggestion-section .unselected-suggestion[data-v-ef69b936]{z-index:4;margin-right:.8em;margin-bottom:.4em;padding:0 2.5em 0 1em;background-color:#4a4a4a;color:#fff;border:1px solid #9b9b9b;position:relative;outline:none;text-transform:capitalize}.main-container .suggestion-section .unselected-suggestion i[data-v-ef69b936]{position:absolute;right:.5em;font-size:1em;top:.2em}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/uploadImage/travel-info.vue"],"names":[],"mappings":"AACA,oDACE,WAAa,CACd,AACD,oEACI,mBAAqB,AACrB,aAAe,AACf,WAAY,AACZ,eAAgB,AAChB,aAAc,AACd,sBAA0B,AAC1B,WAAe,AACf,wBAA0B,CAC7B,AACD,+CACE,cAAe,AACf,UAAa,CACd,AACD,wDACI,oBAAqB,AACrB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC1C,AACD,0DACM,aAAe,CACpB,AACD,8DACM,gBAAiB,AACjB,gBAAiB,AACjB,mBAAqB,AACrB,aAAe,AACf,eAAgB,AAChB,iBAAkB,AAClB,kBAAmB,AACnB,aAAc,AACd,yBAA0B,AAC1B,WAAe,AACf,qBAA0B,CAC/B,AACD,qDACI,kBAAmB,AACnB,eAAiB,CACpB,AACD,gDACE,mBAAoB,AACpB,mBAAoB,AACpB,2BAAgC,AAChC,8BAAmC,AACnC,iBAAmB,CACpB,AACD,oEACI,uBAAwB,AACxB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,SAAW,CACd,AACD,8DACI,SAAU,AACV,SAAU,AACV,kBAAmB,AACnB,kBAAqB,AACrB,yBAA0B,AAC1B,aAAe,CAClB,AACD,wEACI,eAAgB,AAChB,SAAU,AACV,kBAAmB,AACnB,mBAAqB,AACrB,UAAW,AACX,sBAA0B,AAC1B,WAAe,AACf,aAAc,AACd,mBAAqB,AACrB,yBAA0B,AAC1B,gBAAmB,CACtB,AACD,sEACI,iBAAmB,CACtB,AACD,oFACM,kBAAmB,AACnB,eAAiB,AACjB,aAAe,CACpB,AACD,6FACQ,WAAY,AACZ,eAAgB,AAChB,aAAc,AACd,YAAc,CACrB,AACD,iGAEI,cAAe,AACf,SAAW,CAEd,AAOD,yLAEI,cAAe,AACf,SAAW,CAEd,AACD,mFAEI,cAAe,AACf,SAAW,CAEd,AACD,0FACI,UAAW,AACX,kBAAoB,AACpB,mBAAqB,AACrB,sBAAuB,AACvB,sBAAwB,AACxB,WAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,yBAA2B,CAC9B,AACD,4FACM,kBAAmB,AACnB,WAAa,AACb,cAAe,AACf,QAAW,CAChB,AACD,qDACE,wBAA2B,CAC5B,AACD,sEACI,cAAe,AACf,aAAe,CAClB,AACD,4EACI,gBAAkB,AAClB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACvC,AACD,0EACI,UAAW,AACX,kBAAoB,AACpB,mBAAqB,AACrB,sBAAuB,AACvB,yBAA0B,AAC1B,cAAe,AACf,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,yBAA2B,CAC9B,AACD,4EACM,kBAAmB,AACnB,WAAa,AACb,cAAe,AACf,QAAW,CAChB,AACD,4EACI,UAAW,AACX,kBAAoB,AACpB,mBAAqB,AACrB,sBAAuB,AACvB,yBAA0B,AAC1B,WAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,aAAc,AACd,yBAA2B,CAC9B,AACD,8EACM,kBAAmB,AACnB,WAAa,AACb,cAAe,AACf,QAAW,CAChB","file":"travel-info.vue","sourcesContent":["\n.main-container .add-tag-container[data-v-ef69b936] {\n  padding: 2em;\n}\n.main-container .add-tag-container .tag-add-button[data-v-ef69b936] {\n    border-radius: 0.5em;\n    padding: 0.3em;\n    width: 100%;\n    margin-top: 2em;\n    outline: none;\n    background-color: #000000;\n    color: #ffffff;\n    border: 1px solid #f5a623;\n}\n.main-container .head-section[data-v-ef69b936] {\n  padding: 0 1em;\n  color: white;\n}\n.main-container .head-section .actions[data-v-ef69b936] {\n    padding-top: 1.629em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.main-container .head-section .actions i[data-v-ef69b936] {\n      font-size: 1em;\n}\n.main-container .head-section .actions .done[data-v-ef69b936] {\n      font-size: 1.1em;\n      font-weight: 700;\n      border-radius: 0.5em;\n      padding: 0.3em;\n      margin-top: 2em;\n      padding-left: 1em;\n      padding-right: 1em;\n      outline: none;\n      background-color: #bd10e0;\n      color: #ffffff;\n      border: 1px solid #000000;\n}\n.main-container .head-section .head[data-v-ef69b936] {\n    padding-right: 2em;\n    font-size: 1.1em;\n}\n.main-container .input-section[data-v-ef69b936] {\n  min-height: 5.643em;\n  margin-top: 1.857em;\n  border-top: 0.5px solid #000000;\n  border-bottom: 0.5px solid #000000;\n  position: relative;\n}\n.main-container .input-section .clickable-modal-bg[data-v-ef69b936] {\n    background: transparent;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n}\n.main-container .input-section .input-header[data-v-ef69b936] {\n    left: 1em;\n    top: -1em;\n    position: absolute;\n    padding: 0.3em 0.5em;\n    background-color: #4a4a4a;\n    color: #9b9b9b;\n}\n.main-container .input-section .add-new-btn-suggestion[data-v-ef69b936] {\n    cursor: pointer;\n    top: -1em;\n    position: absolute;\n    padding: 0.3em 1.2em;\n    right: 1em;\n    background-color: #000000;\n    color: #ffffff;\n    outline: none;\n    border-radius: 0.5em;\n    border: 1px solid #9b9b9b;\n    font-size: 0.857em;\n}\n.main-container .input-section .selected-suggestions[data-v-ef69b936] {\n    padding: 1.5em 1em;\n}\n.main-container .input-section .selected-suggestions .default-text[data-v-ef69b936] {\n      text-align: center;\n      font-size: 0.9em;\n      color: #f5a623;\n}\n.main-container .input-section .selected-suggestions .default-text textarea[data-v-ef69b936] {\n        width: 100%;\n        font-size: 16px;\n        outline: none;\n        resize: unset;\n}\n.main-container .input-section .selected-suggestions[data-v-ef69b936]::-webkit-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .selected-suggestions[data-v-ef69b936]:-ms-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .selected-suggestions[data-v-ef69b936]::-ms-input-placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .selected-suggestions[data-v-ef69b936]::placeholder {\n    /* Chrome, Firefox, Opera, Safari 10.1+ */\n    color: #b9b9b9;\n    opacity: 1;\n    /* Firefox */\n}\n.main-container .input-section .suggestions-container .added-suggestions[data-v-ef69b936] {\n    z-index: 4;\n    margin-right: 0.8em;\n    margin-bottom: 0.4em;\n    padding: 0 2.5em 0 1em;\n    background-color: black;\n    color: white;\n    border: 1px solid #f5a623;\n    position: relative;\n    outline: none;\n    text-transform: capitalize;\n}\n.main-container .input-section .suggestions-container .added-suggestions i[data-v-ef69b936] {\n      position: absolute;\n      right: 0.5em;\n      font-size: 1em;\n      top: 0.2em;\n}\n.main-container .suggestion-section[data-v-ef69b936] {\n  padding: 1.5em 0.5em 0 1em;\n}\n.main-container .suggestion-section .suggestion-head[data-v-ef69b936] {\n    font-size: 1em;\n    color: #9b9b9b;\n}\n.main-container .suggestion-section .suggestions-container[data-v-ef69b936] {\n    margin-top: 0.5em;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.main-container .suggestion-section .selected-suggestion[data-v-ef69b936] {\n    z-index: 4;\n    margin-right: 0.8em;\n    margin-bottom: 0.4em;\n    padding: 0 2.5em 0 1em;\n    background-color: #9b9b9b;\n    color: #4a4a4a;\n    border: 1px solid #9b9b9b;\n    position: relative;\n    outline: none;\n    text-transform: capitalize;\n}\n.main-container .suggestion-section .selected-suggestion i[data-v-ef69b936] {\n      position: absolute;\n      right: 0.5em;\n      font-size: 1em;\n      top: 0.2em;\n}\n.main-container .suggestion-section .unselected-suggestion[data-v-ef69b936] {\n    z-index: 4;\n    margin-right: 0.8em;\n    margin-bottom: 0.4em;\n    padding: 0 2.5em 0 1em;\n    background-color: #4a4a4a;\n    color: white;\n    border: 1px solid #9b9b9b;\n    position: relative;\n    outline: none;\n    text-transform: capitalize;\n}\n.main-container .suggestion-section .unselected-suggestion i[data-v-ef69b936] {\n      position: absolute;\n      right: 0.5em;\n      font-size: 1em;\n      top: 0.2em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(663);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("1909d018", content, true, {});

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(676);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("1648992a", content, true, {});

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(678);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("daf5af64", content, true, {});

/***/ }),

/***/ 814:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-js-toggle-button"] = factory();
	else
		root["vue-js-toggle-button"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1),
  /* template */
  __webpack_require__(6),
  /* scopeId */
  "data-v-25adc6c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var DEFAULT_COLOR_CHECKED = '#75c791';
var DEFAULT_COLOR_UNCHECKED = '#bfcbd9';
var DEFAULT_LABEL_CHECKED = 'on';
var DEFAULT_LABEL_UNCHECKED = 'off';
var DEFAULT_SWITCH_COLOR = '#fff';
var MARGIN = 3;

var contains = function contains(object, title) {
  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.hasOwnProperty(title);
};

var px = function px(v) {
  return v + 'px';
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ToggleButton',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    sync: {
      type: Boolean,
      default: false
    },
    speed: {
      type: Number,
      default: 300
    },
    color: {
      type: [String, Object],
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.checked || value.unchecked || value.disabled : typeof value === 'string';
      }
    },
    switchColor: {
      type: [String, Object],
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'string';
      }
    },
    cssColors: {
      type: Boolean,
      default: false
    },
    labels: {
      type: [Boolean, Object],
      default: false,
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'boolean';
      }
    },
    height: {
      type: Number,
      default: 22
    },
    width: {
      type: Number,
      default: 50
    },
    fontSize: {
      type: Number
    }
  },
  computed: {
    className: function className() {
      var toggled = this.toggled,
          disabled = this.disabled;


      return ['vue-js-switch', { toggled: toggled, disabled: disabled }];
    },
    coreStyle: function coreStyle() {
      return {
        width: px(this.width),
        height: px(this.height),
        backgroundColor: this.cssColors ? null : this.disabled ? this.colorDisabled : this.colorCurrent,
        borderRadius: px(Math.round(this.height / 2))
      };
    },
    buttonRadius: function buttonRadius() {
      return this.height - MARGIN * 2;
    },
    distance: function distance() {
      return px(this.width - this.height + MARGIN);
    },
    buttonStyle: function buttonStyle() {
      var transition = 'transform ' + this.speed + 'ms';

      var transform = this.toggled ? 'translate3d(' + this.distance + ', 3px, 0px)' : null;

      var background = this.switchColor ? this.switchColorCurrent : null;

      return {
        width: px(this.buttonRadius),
        height: px(this.buttonRadius),
        transition: transition,
        transform: transform,
        background: background
      };
    },
    labelStyle: function labelStyle() {
      return {
        lineHeight: px(this.height),
        fontSize: this.fontSize ? px(this.fontSize) : null
      };
    },
    colorChecked: function colorChecked() {
      var color = this.color;


      if ((typeof color === 'undefined' ? 'undefined' : _typeof(color)) !== 'object') {
        return color || DEFAULT_COLOR_CHECKED;
      }

      return contains(color, 'checked') ? color.checked : DEFAULT_COLOR_CHECKED;
    },
    colorUnchecked: function colorUnchecked() {
      var color = this.color;


      return contains(color, 'unchecked') ? color.unchecked : DEFAULT_COLOR_UNCHECKED;
    },
    colorDisabled: function colorDisabled() {
      var color = this.color;


      return contains(color, 'disabled') ? color.disabled : this.colorCurrent;
    },
    colorCurrent: function colorCurrent() {
      return this.toggled ? this.colorChecked : this.colorUnchecked;
    },
    labelChecked: function labelChecked() {
      var labels = this.labels;


      return contains(labels, 'checked') ? labels.checked : DEFAULT_LABEL_CHECKED;
    },
    labelUnchecked: function labelUnchecked() {
      var labels = this.labels;


      return contains(labels, 'unchecked') ? labels.unchecked : DEFAULT_LABEL_UNCHECKED;
    },
    switchColorChecked: function switchColorChecked() {
      var switchColor = this.switchColor;


      return contains(switchColor, 'checked') ? switchColor.checked : DEFAULT_SWITCH_COLOR;
    },
    switchColorUnchecked: function switchColorUnchecked() {
      var switchColor = this.switchColor;


      return contains(switchColor, 'unchecked') ? switchColor.unchecked : DEFAULT_SWITCH_COLOR;
    },
    switchColorCurrent: function switchColorCurrent() {
      var switchColor = this.switchColor;


      if ((typeof switchColor === 'undefined' ? 'undefined' : _typeof(switchColor)) !== 'object') {
        return switchColor || DEFAULT_SWITCH_COLOR;
      }

      return this.toggled ? this.switchColorChecked : this.switchColorUnchecked;
    }
  },
  watch: {
    value: function value(_value) {
      if (this.sync) {
        this.toggled = !!_value;
      }
    }
  },
  data: function data() {
    return {
      toggled: !!this.value
    };
  },

  methods: {
    toggle: function toggle(event) {
      this.toggled = !this.toggled;
      this.$emit('input', this.toggled);
      this.$emit('change', {
        value: this.toggled,
        srcEvent: event
      });
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Button_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleButton", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a; });


var installed = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  install: function install(Vue) {
    if (installed) {
      return;
    }

    Vue.component('ToggleButton', __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a);
    installed = true;
  }
});



/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".vue-js-switch[data-v-25adc6c0]{display:inline-block;position:relative;overflow:hidden;vertical-align:middle;user-select:none;font-size:10px;cursor:pointer}.vue-js-switch .v-switch-input[data-v-25adc6c0]{opacity:0;position:absolute;width:1px;height:1px}.vue-js-switch .v-switch-label[data-v-25adc6c0]{position:absolute;top:0;font-weight:600;color:#fff;z-index:1}.vue-js-switch .v-switch-label.v-left[data-v-25adc6c0]{left:10px}.vue-js-switch .v-switch-label.v-right[data-v-25adc6c0]{right:10px}.vue-js-switch .v-switch-core[data-v-25adc6c0]{display:block;position:relative;box-sizing:border-box;outline:0;margin:0;transition:border-color .3s,background-color .3s;user-select:none}.vue-js-switch .v-switch-core .v-switch-button[data-v-25adc6c0]{display:block;position:absolute;overflow:hidden;top:0;left:0;transform:translate3d(3px,3px,0);border-radius:100%;background-color:#fff;z-index:2}.vue-js-switch.disabled[data-v-25adc6c0]{pointer-events:none;opacity:.6}", ""]);

// exports


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.className
  }, [_c('input', {
    staticClass: "v-switch-input",
    attrs: {
      "type": "checkbox",
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.toggle($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-switch-core",
    style: (_vm.coreStyle)
  }, [_c('div', {
    staticClass: "v-switch-button",
    style: (_vm.buttonStyle)
  })]), _vm._v(" "), (_vm.labels) ? [(_vm.toggled) ? _c('span', {
    staticClass: "v-switch-label v-left",
    style: (_vm.labelStyle)
  }, [_vm._t("checked", [
    [_vm._v(_vm._s(_vm.labelChecked))]
  ])], 2) : _c('span', {
    staticClass: "v-switch-label v-right",
    style: (_vm.labelStyle)
  }, [_vm._t("unchecked", [
    [_vm._v(_vm._s(_vm.labelUnchecked))]
  ])], 2)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("2283861f", content, true);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(9)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 823:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(697)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(643),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a58d1328",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(850),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ef69b936",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 831:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-page-1-container"
  }, [_c('modal', {
    staticStyle: {},
    attrs: {
      "height": 250,
      "pivotY": 0.5,
      "width": 300,
      "name": "add-new-ea-suggestion"
    }
  }, [_c('div', {
    staticClass: "text-xs-center add-tag-container"
  }, [_c('h3', [_vm._v("Type the tag name!")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "#f5a623",
      "autofocus": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addTagToSelected('EA')
      }
    },
    model: {
      value: (_vm.addTagModal),
      callback: function($$v) {
        _vm.addTagModal = $$v
      },
      expression: "addTagModal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tag-add-button",
    on: {
      "click": function($event) {
        return _vm.addTagToSelected('EA')
      }
    }
  }, [_vm._v("Add Tag")])], 1)]), _vm._v(" "), _c('modal', {
    attrs: {
      "height": 250,
      "pivotY": 0.5,
      "width": 300,
      "name": "add-new-spot-suggestion"
    }
  }, [_c('div', {
    staticClass: "text-xs-center add-tag-container"
  }, [_c('h3', [_vm._v("Type the tag name!")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "#f5a623",
      "autofocus": true
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addTagToSelected('Spot')
      }
    },
    model: {
      value: (_vm.addTagModal),
      callback: function($$v) {
        _vm.addTagModal = $$v
      },
      expression: "addTagModal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tag-add-button",
    on: {
      "click": function($event) {
        return _vm.addTagToSelected('Spot')
      }
    }
  }, [_vm._v("Add Tag")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "upload-screen-1-container"
  }, [_c('div', {
    staticClass: "text-xs-left"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('i', {
    staticClass: "material-icons white--text",
    staticStyle: {
      "font-size": "1.1em",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("arrow_back_ios")]), _vm._v(" "), _c('label', {
    staticClass: "upload-title"
  }, [_vm._v(_vm._s(_vm.$route.query.resourceType == "image" ? 'SUBMIT YOUR PHOTO' : 'SUBMIT YOUR VIDEO'))]), _vm._v(" "), _c('div', {
    staticClass: "tooltip"
  }, [_c('button', {
    staticClass: "done pointer",
    style: (!_vm.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3 ? 'background-color:#5b5b5b;color: #9b9b9b' : 'background-color:#bd10e0;color: #ffffff'),
    attrs: {
      "disabled": !_vm.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3 ? true : false
    },
    on: {
      "click": function($event) {
        _vm.shareUploadedImage({
          isBulk: false,
          photoId: _vm.$route.query.publicId,
          resourceType: _vm.$route.query.resourceType,
          monNDur: {
            mon: _vm._mon2,
            dur: _vm._dur2
          },
          anyoneCanVisitThisSpot: _vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage,
          myPhoto: true,
          hasGeohash: _vm.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3,
          uid: _vm.$store.state.auth.user.uid,
          uploader: 'user',
          caption: _vm.$store.state.uploadImage_2.caption_uploadImage,
          pic_desc: _vm.$store.state.uploadImage_3.travelInfo,
          emotionalAppeal: JSON.stringify(_vm.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage),
          keywords: JSON.stringify(_vm.$store.state.uploadImage_5.selectedKeywords_uploadImage),
          spotType: JSON.stringify(_vm.$store.state.uploadImage_4.selectedSpotType_uploadImage),
          photoSourceLink: _vm.$route.query.photoSourceLink,
          licenseType: '',
          licenseLink: '',
          allowCommercialUse: '',
          approved: false,
          geohash: _vm.$store.state.uploadImage_3.geohashVal,
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$route.query.resourceType == "image" ? 'Submit this photo' : 'Submit this video'))]), _vm._v(" "), (!_vm.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3) ? _c('span', {
    staticClass: "tooltiptext"
  }, [_vm._v(_vm._s(_vm.$route.query.resourceType == "image" ? 'Please select photo location first.' : 'Please select video location first'))]) : _vm._e()])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "img-and-caption-container",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "img-container",
    attrs: {
      "xs4": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [(_vm.$route.query.resourceType == 'image') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.uploadedImgUrl),
      expression: "uploadedImgUrl"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.$route.query.resourceType == 'video') ? _c('div', {
    staticClass: "video-container"
  }, [(_vm.$route.query.resourceType == 'video') ? _c('div', {
    staticClass: "video-player",
    staticStyle: {
      "position": "relative",
      "height": "100%",
      "width": "600px"
    }
  }, [(_vm.$route.query.photoSourceLink.includes('vimeo')) ? _c('iframe', {
    staticStyle: {
      "top": "0",
      "bottom": "0",
      "height": "90%",
      "width": "100%",
      "right": "0"
    },
    attrs: {
      "src": _vm.getVideoLink(_vm.$route.query.photoSourceLink),
      "frameborder": "0",
      "allow": "autoplay; fullscreen",
      "allowfullscreen": ""
    },
    on: {
      "load": function($event) {
        _vm.imgLoader = false
      }
    }
  }) : _c('youtube', {
    staticClass: "video-player-youtube",
    attrs: {
      "id": "yt_video",
      "video-id": _vm.getVideoId(_vm.$route.query.photoSourceLink),
      "player-width": "100%",
      "player-height": "90%"
    },
    on: {
      "pause": _vm.pause,
      "ready": _vm.ready,
      "playing": _vm.playing
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "location-piblic-access"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [(!JSON.parse(_vm.$route.query.geoLocIsAvailable)) ? _c('div', {
    staticClass: "input-container white--text padding-bottom padding-top location-container"
  }, [(_vm.locationAddress.length !== 0) ? _c('div', {
    staticClass: "input-container-text"
  }, [_c('button', {
    staticClass: "add-location",
    on: {
      "click": function($event) {
        _vm.$modal.show('mapModal');
        _vm.$store.state.uploadImage_2.openMapDialog = true
      }
    }
  }, [_vm._v("\n                  Change photo location\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "address",
    staticStyle: {
      "font-size": "12px",
      "margin-top": "2px"
    }
  }, [_vm._v(_vm._s(_vm.locationAddress))])]) : _c('div', {
    staticClass: "location-button"
  }, [_c('button', {
    staticClass: "add-location-new",
    on: {
      "click": function($event) {
        _vm.$modal.show('mapModal');
        _vm.$store.state.uploadImage_2.openMapDialog = true
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$route.query.resourceType == "image" ? 'Select photo location' : 'Select video location') + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-container public-spot-container"
  }, [_c('label', {
    staticClass: "container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage),
      expression: "$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage) ? _vm._i(_vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage, null) > -1 : (_vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.uploadImage_4, "anyoneCanVisitThisSpot_uploadImage", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.uploadImage_4, "anyoneCanVisitThisSpot_uploadImage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.uploadImage_4, "anyoneCanVisitThisSpot_uploadImage", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label heading-text"
  }, [_vm._v("Public spot")]), _vm._v(" "), _c('div', {
    staticClass: "input-container-text white--text sub-text"
  }, [_vm._v("Photo is NOT taken from a private property")])])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption-container",
    attrs: {
      "xs8": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "caption-title"
  }, [_vm._v("Give it a beautiful caption")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.uploadImage_2.caption_uploadImage),
      expression: "$store.state.uploadImage_2.caption_uploadImage"
    }],
    staticClass: "caption-text-area",
    attrs: {
      "placeholder": "Start typing here ..."
    },
    domProps: {
      "value": (_vm.$store.state.uploadImage_2.caption_uploadImage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.uploadImage_2, "caption_uploadImage", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("Describe the feel of this place")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left white--text selected-tags-upload"
  }, [_c('div', {
    staticClass: "selected-suggestions"
  }, [(_vm.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.length != 0) ? _c('div', _vm._l((_vm.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage), function(selected_suggestion, sIndex) {
    return _c('label', {
      key: ("" + sIndex)
    }, [_vm._v(_vm._s(selected_suggestion) + _vm._s(sIndex === _vm.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.length - 1 ? '' : ', '))])
  }), 0) : _c('div', [_c('label', {
    staticClass: "selected-tags-placeholder"
  }, [_vm._v("Select below or add new...")])])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "flex-grow-1": ""
    }
  }, [_c('div', {
    staticClass: "suggestions-container",
    attrs: {
      "id": "selected-emotional-appeal"
    }
  }, _vm._l((this.vibeSuggestions), function(suggestion, sIndex) {
    return _c('div', {
      key: ("" + sIndex),
      staticClass: "unselected-suggestion-pills pointer",
      attrs: {
        "id": ("ea" + sIndex)
      },
      on: {
        "click": function($event) {
          return _vm.addOrRemove(suggestion, 'EA', ("ea" + sIndex))
        }
      }
    }, [_vm._v(_vm._s(suggestion))])
  }), 0)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "add-new-btn-suggestion pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.show('add-new-ea-suggestion')
      }
    }
  }, [_vm._v("Add new")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("This photo was taken from …")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left white--text selected-tags-upload"
  }, [_c('div', {
    staticClass: "selected-suggestions",
    attrs: {
      "id": "selected-spot-types"
    }
  }, [(_vm.$store.state.uploadImage_4.selectedSpotType_uploadImage.length != 0) ? _c('div', _vm._l((_vm.$store.state.uploadImage_4.selectedSpotType_uploadImage), function(selected_suggestion, sIndex) {
    return _c('label', {
      key: ("" + sIndex)
    }, [_vm._v(_vm._s(selected_suggestion) + _vm._s(sIndex === _vm.$store.state.uploadImage_4.selectedSpotType_uploadImage.length - 1 ? '' : ', '))])
  }), 0) : _c('div', [_c('label', {
    staticClass: "selected-tags-placeholder"
  }, [_vm._v("Select below or add new...")])])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "flex-grow-1": ""
    }
  }, [_c('div', {
    staticClass: "suggestions-container"
  }, _vm._l((this.spotSuggestions), function(suggestion, sIndex) {
    return _c('div', {
      key: ("" + sIndex),
      staticClass: "unselected-suggestion-pills pointer",
      attrs: {
        "id": ("s" + sIndex)
      }
    }, [_c('button', {
      on: {
        "click": function($event) {
          return _vm.addOrRemove(suggestion, 'spot', ("s" + sIndex))
        }
      }
    }, [_vm._v(_vm._s(suggestion))])])
  }), 0)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "add-new-btn-suggestion pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.show('add-new-spot-suggestion')
      }
    }
  }, [_vm._v("Add new")])])], 1)], 1), _vm._v(" "), (_vm.$route.query.createdAt == '') ? _c('div', {
    staticClass: "image-datetime-upload-heading"
  }, [_vm._v("When was this photo taken?")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.createdAt == '') ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    ref: "dialog1",
    attrs: {
      "return-value": _vm.date,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', _vm._g(_vm._b({
          staticClass: "date-time-input-box",
          style: (_vm.date == '' ? 'color:#b9b9b9' : 'color:#f5a623')
        }, 'div', attrs, false), on), [_vm._v(_vm._s(_vm.date == '' ? 'Select a date' : _vm.date))]), _vm._v(" "), _c('div', _vm._g(_vm._b({}, 'div', attrs, false), on), [_c('i', {
          staticClass: "material-icons",
          staticStyle: {
            "cursor": "pointer",
            "color": "white"
          }
        }, [_vm._v("calendar_today")])])])]
      }
    }], null, false, 3036176884),
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "max": _vm.currentDate,
      "scrollable": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialog1.save(_vm.date)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "return-value": _vm.time,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.time = $event
      },
      "update:return-value": function($event) {
        _vm.time = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', _vm._g(_vm._b({
          staticClass: "date-time-input-box",
          style: (_vm.time == '' ? 'color:#b9b9b9' : 'color:#f5a623')
        }, 'div', attrs, false), on), [_vm._v(_vm._s(_vm.time == '' ? 'Select a time' : _vm.time))]), _vm._v(" "), _c('div', _vm._g(_vm._b({
          staticStyle: {
            "cursor": "pointer",
            "color": "white"
          }
        }, 'div', attrs, false), on), [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("access_time")])])]), _vm._v(" "), _c('p', {
          staticStyle: {
            "visibility": "hidden"
          }
        }, [_vm._v(_vm._s(_vm.submittableDateTime))])]
      }
    }], null, false, 270264626),
    model: {
      value: (_vm.modal2),
      callback: function($$v) {
        _vm.modal2 = $$v
      },
      expression: "modal2"
    }
  }, [_vm._v(" "), (_vm.modal2) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr",
      "full-width": ""
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.modal2 = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialog.save(_vm.time)
      }
    }
  }, [_vm._v("OK")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('modal', {
    staticClass: "mapModal",
    attrs: {
      "name": "mapModal",
      "width": "60%",
      "height": "auto"
    },
    on: {
      "closed": function($event) {
        _vm.$store.state.uploadImage_2.openMapDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "white"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageLocation),
      expression: "imageLocation"
    }],
    staticClass: "map-input-box",
    attrs: {
      "id": "pac-input",
      "placeholder": "Search location here..."
    },
    domProps: {
      "value": (_vm.imageLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageLocation = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blue--text my-loc-btn",
    attrs: {
      "id": "locBut"
    },
    on: {
      "click": _vm.getCurrentGeoLocation
    },
    nativeOn: {
      "click": function($event) {
        _vm.$store.state.uploadImage_3.getCenter = true
      }
    }
  }, [_c('v-icon', [_vm._v("location_searching")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "myMap"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.showMapTooltip()
      },
      "mouseleave": function($event) {
        return _vm.hideMapTooltip()
      }
    }
  }, [_c('button', {
    class: _vm.imageLocation === '' ? 'select-loc-btn-disabled' : 'select-loc-btn',
    attrs: {
      "disabled": _vm.imageLocation === '' ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.selectMarkerLocation()
      }
    }
  }, [_vm._v("SELECT THIS LOCATION")]), _vm._v(" "), (_vm.imageLocation === '' ? _vm.mapTooltip : '') ? _c('span', {
    staticClass: "map-tooltiptext"
  }, [_vm._v(_vm._s(_vm.$route.query.resourceType == "image" ? 'Please select photo location first.' : 'Please select video location first'))]) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container",
    staticStyle: {
      "height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('modal', {
    attrs: {
      "height": 250,
      "pivotY": 0.5,
      "width": 300,
      "name": "add-new-suggestion"
    }
  }, [_c('div', {
    staticClass: "text-xs-center add-tag-container"
  }, [_c('h3', [_vm._v("Type the tag name!")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "#f5a623",
      "autofocus": true
    },
    model: {
      value: (_vm.addTagModal),
      callback: function($$v) {
        _vm.addTagModal = $$v
      },
      expression: "addTagModal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tag-add-button",
    on: {
      "click": function($event) {
        return _vm.addTagToSelected()
      }
    }
  }, [_vm._v("Add Tag")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "head-section"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('div', [_c('i', {
    staticClass: "material-icons white--text",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('suggestions')
      }
    }
  }, [_vm._v("arrow_back_ios")])]), _vm._v(" "), _c('div', {
    staticClass: "done",
    on: {
      "click": function($event) {
        return _vm.emitArrayAsTextObjArr()
      }
    }
  }, [_vm._v("Done")])]), _vm._v(" "), _c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v(_vm._s(_vm.headTag))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.subheadTag))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-section",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "input-header"
  }, [_vm._v("Your input")]), _vm._v(" "), _c('div', {
    staticClass: "clickable-modal-bg",
    on: {
      "click": function($event) {
        return _vm.$modal.show('add-new-suggestion')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "add-new-btn-suggestion pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.show('add-new-suggestion')
      }
    }
  }, [_vm._v("Add new")]), _vm._v(" "), _c('div', {
    staticClass: "selected-suggestions"
  }, [(_vm.selectedSuggestions.length === 0) ? _c('div', {
    staticClass: "default-text"
  }, [_vm._v("Add a new one or select from the suggestions below.")]) : _c('div', {
    staticClass: "suggestions-container"
  }, _vm._l((_vm.selectedSuggestions), function(suggestion, sIndex) {
    return _c('button', {
      key: ("" + sIndex),
      staticClass: "added-suggestions",
      on: {
        "click": function($event) {
          return _vm.addOrRemove(suggestion)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("\n            " + _vm._s(_vm.selectedSuggestions.includes(suggestion) ?
      'cancel' : 'add') + "\n          ")]), _vm._v("\n          " + _vm._s(suggestion) + "\n        ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "suggestion-section white--text"
  }, [_c('div', {
    staticClass: "suggestion-head"
  }, [_vm._v("SUGGESTIONS")]), _vm._v(" "), _c('div', {
    staticClass: "suggestions-container"
  }, _vm._l((_vm.suggestions), function(suggestion, sIndex) {
    return _c('div', {
      key: ("" + sIndex)
    }, [_c('button', {
      class: _vm.selectedSuggestions.includes(suggestion) ?
        'selected-suggestion' : 'unselected-suggestion',
      on: {
        "click": function($event) {
          return _vm.addOrRemove(suggestion)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("\n            " + _vm._s(_vm.selectedSuggestions.includes(suggestion) ?
      'cancel' : 'add') + "\n          ")]), _vm._v("\n          " + _vm._s(suggestion) + "\n        ")])])
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 850:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "head-section"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('div', [_c('i', {
    staticClass: "material-icons white--text",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('suggestions')
      }
    }
  }, [_vm._v("arrow_back_ios")])]), _vm._v(" "), _c('div', {
    staticClass: "done",
    on: {
      "click": function($event) {
        return _vm.fillTravelInfo()
      }
    }
  }, [_vm._v("\n        Done\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v(_vm._s(_vm.headTag))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.subheadTag))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-section"
  }, [_c('div', {
    staticClass: "input-header"
  }, [_vm._v("\n      Your input\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "selected-suggestions"
  }, [_c('div', {
    staticClass: "default-text text-xs-left"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.travel),
      expression: "travel"
    }],
    attrs: {
      "placeholder": "Tap here to start writing travel tips."
    },
    domProps: {
      "value": (_vm.travel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.travel = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suggestion-section white--text"
  }, [_c('div', {
    staticClass: "suggestion-ques"
  }, [_vm._v("\n      Example questions to answer as travel tips.\n      "), _c('br'), _vm._v("\n      What is this spot about?\n      "), _c('br'), _vm._v("\n      \u2028Why should others visit this place?\n      "), _c('br'), _vm._v("\n      Is it a crowded or touristic location?\n      "), _c('br'), _vm._v("\n      What is the best daytime and season to visit?\u2028\n      "), _c('br'), _vm._v("\n      How can one get to the exact photo spot?\n      "), _c('br'), _vm._v("\n      Is parking available?\u2028\n    ")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/6.2963dfd4ee0e4194b70f.js